// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:55:11.193Z
// Property: Shadow Hills (ID: 6767906449166905)
// Collections: 31 amenities, 7 floorplans (live), 35 photos, 43 POIs, 3 reviews, 4 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166905",
  "property_external_id": "495781",
  "property_zillow_url": "https://www.zillow.com/homedetails/2222-SW-Vermont-St-Portland-OR-97219/2094427972_zpid/",
  "property_apartments_url": "https://www.apartments.com/shadow-hills-portland-or/ckhpmsf/",
  "property_google_business_url": "https://www.google.com/maps/place/Shadow+Hills+Apartments/data=!4m2!3m1!1s0x0:0xbd69bce1db3767b5?sa=X&ved=2ahUKEwin7LDYlrySAxWWF1kFHefNKbcQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495781 p0505449",
  "property_status": null,
  "property_slug": "shadow-hills",
  "property_name": "Shadow Hills",
  "property_website_url": "http://www.portlandoregon-apartments.net/",
  "property_domain": "https://www.portlandoregon-apartments.net/",
  "property_address": "2040 Southwest Vermont Street",
  "property_full_address": "2040 SW Vermont St, Portland, OR 97219",
  "property_address_1": "2040 Southwest Vermont Street",
  "property_address_2": null,
  "property_address_city": "Portland",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97219",
  "property_address_country": "US",
  "property_address_county": "Multnomah County",
  "property_neighborhood_address": "Southwest Portland",
  "property_address_latitude": "45.4750576",
  "property_address_longitude": "-122.6996771",
  "property_email": "shadowhills@ctlmanagement.com",
  "property_phone": "(503) 831-9122",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Shadow Hills, your oasis in Portland, OR! Choose from spacious one, two, or three-bedroom floor plans and enjoy top-notch amenities, including a 24-hour fitness center, refreshing swimming pool, and a bark park for your furry friends. Embrace a lifestyle of comfort—schedule a tour and find your perfect home today!",
  "property_long_description": "Welcome to Shadow Hills, your serene sanctuary in the heart of Portland, OR! Our vibrant apartment community offers a variety of thoughtfully designed floor plans, including spacious one-bedroom, two-bedroom, and three-bedroom apartments, tailored to suit your lifestyle. At Shadow Hills, you’ll find everything you need to feel at home, along with an array of outstanding amenities that enhance your living experience.\n\nStay active year-round in our 24-hour fitness center, or unwind and relax by our sparkling swimming pool. After a workout, indulge in a soothing sauna session or host a gathering in our inviting clubhouse equipped with complimentary Wi-Fi. Your furry friends are welcome too! Let them run free in our bark park while you enjoy peace of mind with our convenient covered parking options.\n\nLocated in a dynamic neighborhood of Portland, Shadow Hills ensures you're always just moments away from local attractions, shopping, and dining. Our accommodating pet policy means that your beloved pets can enjoy life here just as much as you do.\n\nDon't miss the opportunity to make Shadow Hills your new home! Explore our available floor plans and discover the ideal space that fits your needs. Whether you’re looking for a cozy one-bedroom retreat or a spacious three-bedroom home for your family, we have the perfect space for you. \n\nFind your new home today—browse our availability or schedule a tour to visit our community! Shadow Hills is ready to welcome you home.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d3145-8640-73aa-b3ed-d89c503007fc.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment building exterior with a winding walkway and lush landscaping at sunset.",
    "public_id": "019d3145-8640-73aa-b3ed-d89c503007fc",
    "storage_key": "property/6767906449166905/019d3145-8640-73aa-b3ed-d89c503007fc.webp",
    "width": 2048,
    "height": 956
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "220",
  "property_year_built": "1972",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.18181818181817",
  "property_admin_fee": null,
  "property_application_fee": "22",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://shadowhills.securecafe.com/onlineleasing/shadow-hills-0/guestlogin",
  "property_resident_portal_url": "https://shadowhills.securecafenet.com/residentservices/shadow-hills-0/userlogin",
  "property_apply_now_url": "https://portlandoregon-apartments.securecafe.com/onlineleasing/shadow-hills-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d7407-1123-73d9-a8e5-3ec37ae751fd.webp",
  "property_primary_logo_media": {
    "alt_text": "Shadow Hills Apartments logo",
    "public_id": "019d7407-1123-73d9-a8e5-3ec37ae751fd",
    "storage_key": "property/6767906449166905/019d7407-1123-73d9-a8e5-3ec37ae751fd.webp",
    "width": 612,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d7407-1131-72ef-b06d-ce6f7d989f15.webp",
  "property_secondary_logo_media": {
    "alt_text": "Shadow Hills Apartments logo",
    "public_id": "019d7407-1131-72ef-b06d-ce6f7d989f15",
    "storage_key": "property/6767906449166905/019d7407-1131-72ef-b06d-ce6f7d989f15.webp",
    "width": 609,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019de0b2-7be4-73bc-be5d-dc586a4b7fe0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic graphic placeholder",
    "public_id": "019de0b2-7be4-73bc-be5d-dc586a4b7fe0",
    "storage_key": "property/6767906449166905/019de0b2-7be4-73bc-be5d-dc586a4b7fe0.webp",
    "width": 612,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019de0b2-6f86-7298-80d7-cd26b92ba261.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle placeholder",
    "public_id": "019de0b2-6f86-7298-80d7-cd26b92ba261",
    "storage_key": "property/6767906449166905/019de0b2-6f86-7298-80d7-cd26b92ba261.webp",
    "width": 612,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "750 - 1170",
  "property_sqft_min": "750",
  "property_sqft_max": "1170",
  "property_price_range": "1450 - 2215",
  "property_price_min": "1450",
  "property_price_max": "2215",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/shadowhillsapartmenthomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJr4pl0gcLlVQRtWc32-G8ab0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=shadow-hills-apartments-portland",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Shadow Hills",
  "property_home_romance_title": "Embrace the Joy of Living in Your Perfect Apartment",
  "property_home_amenities_blurb": "Welcome to Shadow Hills in vibrant Portland, OR, where stylish one-, two-, and three-bedroom apartments await. Embrace an active lifestyle with our 24-hour fitness center, refreshing swimming pool, and peaceful bark park. Unwind in our inviting clubhouse, all while enjoying the convenience of covered parking and pet-friendly policies.",
  "property_home_floorplans_blurb": "Welcome to Shadow Hills, where urban living meets serene landscapes in the heart of Portland, OR. With thoughtfully designed floor plans to suit every lifestyle, our vibrant community invites you to embrace comfort and style. Browse our available apartment homes today and uncover the ideal space tailored just for you!",
  "property_home_gallery_blurb": "At Shadow Hills in vibrant Portland, OR, your ideal home awaits. Choose from spacious one-to-three bedroom layouts featuring top-notch amenities like a 24-hour fitness center, a refreshing pool, and a welcoming bark park for your furry friends. Picture yourself living here, surrounded by comfort and convenience!",
  "property_home_neighborhood_blurb": "At Shadow Hills in Portland, OR, your new home connects you to vibrant culture and adventure. Enjoy easy access to the stunning Portland Japanese Garden, expansive Laurelhurst Park, and esteemed Lewis & Clark College. Find your ideal one, two, or three-bedroom floor plan and embrace a lifestyle rich in local favorites.",
  "property_home_reviews_blurb": "Nestled in the heart of Portland, Shadow Hills radiates a vibrant community spirit. Our residents rave, \"The welcoming staff and lush surroundings make this place feel like home!\" Dive into the experiences that shape our exceptional living spaces. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Experience the vibrant charm of Portland at Shadow Hills, where cultural treasures await just outside your door. Stroll through the lush Portland Japanese Garden, explore the historic Powell's City of Books, or enjoy events at the Moda Center. Dive into a community rich with both excitement and convenience. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Shadow Hills in Portland, OR, experience the perfect blend of comfort and convenience. Our spacious one, two, and three-bedroom floor plans welcome you home. Enjoy a refreshing swim, invigorate in the 24-hour fitness center, or unwind in the sauna—all while your pets roam freely in our bark park.",
  "property_applynow_blurb": "At Shadow Hills in vibrant Portland, OR, our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Unwind in our sparkling swimming pool, de-stress in the sauna, or let your furry friend roam in the bark park. Lease online today and experience the perfect blend of comfort and convenience!",
  "property_contactus_blurb": "At Shadow Hills in Portland, OR, find the perfect floor plan tailored to your lifestyle—whether it's a cozy one-bedroom or a spacious three-bedroom retreat. Our diverse options invite you to choose your ideal home. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Shadow Hills in Portland, OR, we offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments perfect for your lifestyle. Have questions? Our FAQs page is your go-to resource for everything you need to know about our vibrant community. Get informed today!",
  "property_floorplans_blurb": "At Shadow Hills in Portland, OR, we offer thoughtfully designed floor plans tailored to your lifestyle. Whether you're seeking a cozy one-bedroom retreat, a spacious two-bedroom haven, or a generous three-bedroom layout, each apartment provides the perfect canvas for your personal touch. Browse our available apartment homes today!",
  "property_gallery_blurb": "At Shadow Hills in vibrant Portland, OR, picture yourself immersed in a lifestyle of comfort. Our spacious one to three-bedroom apartments feature a 24-hour fitness center, sparkling swimming pool, and a welcoming clubhouse. Enjoy leisurely walks in the bark park or unwind in the sauna—your ideal home awaits!",
  "property_interactivemap_blurb": "Welcome to Shadow Hills in Portland, OR, where comfort meets convenience. Choose from cozy one, two, or three-bedroom layouts, all complemented by top-tier amenities like a 24-hour fitness center, serene sauna, and a refreshing swimming pool. Navigate our interactive community map and find your perfect apartment today!",
  "property_pets_blurb": "At Shadow Hills in vibrant Portland, OR, your furry friends are cherished members of the family. With a welcoming policy for small dogs and indoor cats, plus an array of small caged pets, your home will truly feel complete. Elevate your living experience amidst nature's beauty and urban charm.",
  "property_referafriend_blurb": "At Shadow Hills in vibrant Portland, OR, the joy of living expands with our spacious one, two, and three-bedroom apartments. Share the experience by bringing a friend into our welcoming community—great friends make great neighbors! Refer today and enhance your lifestyle together in our stunning surroundings. ",
  "property_residentaccess_blurb": "Welcome to Shadow Hills in vibrant Portland, OR! Access your resident portal for hassle-free rent payments, maintenance requests, and more. Whether you’re in a cozy one-bedroom or a spacious three-bedroom, we're dedicated to making your living experience seamless and enjoyable. Log in and take control of your home today!",
  "property_reviews_blurb": "At Shadow Hills in vibrant Portland, OR, residents rave about the community's charm, stating, “The friendly atmosphere and stunning views make every day special.” Join a neighborhood where comfort and connection thrive. See what our residents have to say about living at our community!",
  "property_created_at": "1762785098358",
  "property_scheduletour_blurb": "At Shadow Hills in Portland, OR, your perfect home awaits among our thoughtfully designed one, two, and three-bedroom floor plans. Experience the vibrant community and breathtaking surroundings. Schedule a tour today and hear firsthand from our residents about the unmatched lifestyle we offer at Shadow Hills!",
  "property_thankyou_blurb": "Thank you for reaching out to Shadow Hills in vibrant Portland, OR! With spacious one, two, and three-bedroom floor plans, your ideal home awaits among breathtaking landscapes. Our team will connect soon to help you explore these exceptional living spaces tailored just for you. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "At Shadow Hills in vibrant Portland, OR, you'll find an array of thoughtfully designed floor plans, from cozy one-bedrooms to spacious three-bedrooms, tailored to your lifestyle. Experience the charm and comfort of our community—take a virtual tour today and envision your new home! ",
  "property_copyright": "2025 All Rights Reserved. Shadow Hills",
  "property_seo_title_home": "Shadow Hills |  Apartments in Portland, OR",
  "property_seo_description_home": "Experience Portland living at Shadow Hills! Enjoy spacious floor plans, a fitness center, pool, and pet-friendly amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Portland, OR Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal living space at Shadow Hills in Portland, OR. Choose from spacious one, two, and three-bedroom floor plans—your dream home awaits!",
  "property_seo_title_amenities": "Amenities | Portland, OR Apartments for Rent",
  "property_seo_description_amenities": "Uncover the charm of Shadow Hills in Portland! Enjoy a fitness center, pool, sauna, and pet-friendly spaces—your ideal living awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in Portland, OR",
  "property_seo_description_gallery": "Experience life at Shadow Hills, Portland! Choose from beautiful 1-3 BR floor plans and enjoy top-notch amenities like a pool and fitness center.",
  "property_seo_title_virtualtours": "Virtual Tours | Shadow Hills Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Shadow Hills in Portland! Take a virtual tour to find your ideal one, two, or three-bedroom apartment in our welcoming community.",
  "property_seo_title_interactivemap": "Interactive Map | Shadow Hills Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Shadow Hills in Portland! Use our interactive map to explore spacious one, two, and three-bedroom apartments and fantastic amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Portland, OR",
  "property_seo_description_neighborhood": "Experience the vibrant life around Shadow Hills in Portland, OR—explore local gems and hotspots just steps from your new one, two, or three-bedroom home!",
  "property_seo_title_contact": "Contact Us | Shadow Hills",
  "property_seo_description_contact": "Reach out to Shadow Hills in Portland, OR! Our leasing team is ready to answer your questions about one to three-bedroom floor plans and more.",
  "property_seo_title_faqs": "FAQs | Apartments in Portland, OR",
  "property_seo_description_faqs": "Unlock your questions about Shadow Hills in Portland! From floor plans to pet policies, our FAQs page has everything you need for a seamless living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Portland, OR",
  "property_seo_description_reviews": "Hear from Shadow Hills residents in Portland, OR! Discover why our community with a 24-hour fitness center, pool, and pet-friendly amenities feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Portland, OR",
  "property_seo_description_applynow": "Find your sanctuary at Shadow Hills in Portland, OR. Experience modern living with top-notch amenities and flexible floor plans. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Shadow Hills",
  "property_seo_description_residentaccess": "Unlock convenience at Shadow Hills in Portland, OR! Log in to your resident portal to effortlessly pay rent, schedule maintenance, and manage your home.",
  "property_seo_title_referafriend": "Refer A Friend | Shadow Hills",
  "property_seo_description_referafriend": "Refer a friend to Shadow Hills in Portland, OR! Great friends make great neighbors—share the experience of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Shadow Hills",
  "property_seo_description_scheduletour": "Experience the allure of Shadow Hills in Portland, OR. Schedule a tour today and step into your dream home surrounded by nature and modern comforts!",
  "property_seo_title_privacy": "Privacy Policy | Shadow Hills",
  "property_seo_description_privacy": "At Shadow Hills in Portland, our commitment to your privacy is paramount. Learn more about our policies and how we protect your information. Read now!",
  "property_seo_title_accessibility": "Website Accessibility | Shadow Hills",
  "property_seo_description_accessibility": "At Shadow Hills in Portland, we prioritize digital inclusion for all. Experience our commitment to accessibility and enjoy a seamless living experience.",
  "property_seo_title_sitemap": "Sitemap | Shadow Hills",
  "property_seo_description_sitemap": "Navigate your way to comfort at Shadow Hills in Portland, OR. Discover every aspect of our community through our detailed sitemap—your journey starts here!",
  "property_seo_title_thankyou": "Thank You | Shadow Hills",
  "property_seo_description_thankyou": "Thank you for reaching out to Shadow Hills! We're excited to connect soon and help you find your perfect Portland home nestled in serene surroundings.",
  "property_seo_title_pets": "Pet Policy | Apartments in Portland, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778875105575",
  "amenities": [
    {
      "id": "ec_e474d0016545e28754045a13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "86391316",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf265019be3ce866c2f3bd74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428484",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-0d6c-7278-977b-0124d37d9af4.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio machines, weights, and exercise equipment.",
        "public_id": "019d4975-0d6c-7278-977b-0124d37d9af4",
        "storage_key": "property/6767906449166905/019d4975-0d6c-7278-977b-0124d37d9af4.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Shadow Hills fitness center and free weights,State Of Art Fitness Center at Shadow Hills, Oregon, 97219,Shadow Hills fitness center and equipment",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3f9522b51587e123f802481",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428492",
      "title": "Sauna",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebf8beda8b2ed8aa0cf11795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428493",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-39ef-719b-89c7-a3450638136b.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and a playground in the background.",
        "public_id": "019d4975-39ef-719b-89c7-a3450638136b",
        "storage_key": "property/6767906449166905/019d4975-39ef-719b-89c7-a3450638136b.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Large Pool View at Shadow Hills, Portland Oregon,Resort Style Pool at Shadow Hills, Portland, 97219,Outdoor Swimming Pool at Shadow Hills, Portland, OR",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0be9fd5e8268e1480cb95d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "120949394",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-414d-7531-93dc-8d7ccaeeb70b.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and swings in front of apartment buildings",
        "public_id": "019d4975-414d-7531-93dc-8d7ccaeeb70b",
        "storage_key": "property/6767906449166905/019d4975-414d-7531-93dc-8d7ccaeeb70b.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Play Area at Shadow Hills, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bf65eaf52196d7d503cc520",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428488",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a73f39e4613afe0f7646694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428487",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-00e3-75f9-9bd2-064b43255301.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a row of garages with tan doors and blue siding.",
        "public_id": "019d4975-00e3-75f9-9bd2-064b43255301",
        "storage_key": "property/6767906449166905/019d4975-00e3-75f9-9bd2-064b43255301.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Garages Available at Shadow Hills, Portland, OR 97219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d50061aba4d2ec6cc51a6672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428494",
      "title": "Covered Parking - With Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da0958f304392d90a4cc49d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428491",
      "title": "On Bus Line",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c7e9f3112f8b8608578af58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "86393179",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0294ee317488ae2c6d5d6963",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "86393178",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6c51592bee59c7f5fbbd096",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87376358",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-466e-75f2-a3ab-6550849cfefa.webp",
      "amenity_image_media": {
        "alt_text": "Fenced dog park with wood chips, benches, and agility equipment.",
        "public_id": "019d4975-466e-75f2-a3ab-6550849cfefa",
        "storage_key": "property/6767906449166905/019d4975-466e-75f2-a3ab-6550849cfefa.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Bark Park at Shadow Hills, Portland",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50567f38901c2e4a04c53995",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "86393180",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_956bd0930daa90eaaf359dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428490",
      "title": "Nature Paths",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-00ed-74ef-8203-ffa611ccb9dd.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings surrounded by lush trees and green grass.",
        "public_id": "019d4975-00ed-74ef-8203-ffa611ccb9dd",
        "storage_key": "property/6767906449166905/019d4975-00ed-74ef-8203-ffa611ccb9dd.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Green Space And Trees at Shadow Hills, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f10103903889b199cb69dc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428489",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_819bee251a9ea613257f2f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "82390253",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0d7d19e9403eef27b3760c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "82390255",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3ed99003808e6d0c21f5e21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "86393181",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_666424c76054bfaaef5bee3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428499",
      "title": "In-Unit Washer & Dryer - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4521bee4b10a2771230582b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428495",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9916fbda846670f0f87fa6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310457",
      "title": "Fully Upgraded Kitchens - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-a690-7664-8e0b-cb02c9b2c9f3.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with black refrigerator, stove, and dark wood cabinets.",
        "public_id": "019d4975-a690-7664-8e0b-cb02c9b2c9f3",
        "storage_key": "property/6767906449166905/019d4975-a690-7664-8e0b-cb02c9b2c9f3.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Black Appliances at Shadow Hills, Portland,Kitchen With Living Room at Shadow Hills, Portland Oregon,Kitchen Appliances at Shadow Hills, Portland, 97219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_723e0fe65de63105c19e641d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310458",
      "title": "Wide Variety of Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4755bc6dc0e8a366b797cfb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310453",
      "title": "Walk-In Closet - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e302b484d2fc55dab180d302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310450",
      "title": "Oversized Balcony - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d594f-957d-7311-9fcd-89284d6dee7f.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and green lawn.",
        "public_id": "019d594f-957d-7311-9fcd-89284d6dee7f",
        "storage_key": "property/6767906449166905/019d594f-957d-7311-9fcd-89284d6dee7f.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Outdoor Green Landscape at Shadow Hills, Oregon, 97219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f18037c4dab8b595fd2acf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310451",
      "title": "Double Sliding Glass Doors To Deck - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-822f-7166-a268-8d3c5da589ee.webp",
      "amenity_image_media": {
        "alt_text": "Living room with sliding glass doors leading to a balcony and view of trees.",
        "public_id": "019d4975-822f-7166-a268-8d3c5da589ee",
        "storage_key": "property/6767906449166905/019d4975-822f-7166-a268-8d3c5da589ee.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Spacious Living Area at Shadow Hills, Portland, OR 97219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b258c529b550294148d1fe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310454",
      "title": "Attached Storage - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1053f668b8398ff4d222079d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310455",
      "title": "Scenic Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-00ed-74ef-8203-ffa611ccb9dd.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings surrounded by lush trees and green grass.",
        "public_id": "019d4975-00ed-74ef-8203-ffa611ccb9dd",
        "storage_key": "property/6767906449166905/019d4975-00ed-74ef-8203-ffa611ccb9dd.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Garden Area at Shadow Hills, Portland, OR",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_132b415990dc7cbb1514e2ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310456",
      "title": "Vaulted Ceiling - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_490d0ac409b98ef28c7dcfed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "87310452",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1427aa517a34e52c136edaad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "80428496",
      "title": "Smoke Free Housing - See Policy",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39b8d950c5f705f02ed47e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "yardi",
      "external_id": "123623758",
      "title": "Covered Parking*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_425552cdcd917f893c6d24c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d42aa-a676-70fa-9daf-d8a720ed8bbd.webp",
      "image_media": {
        "alt_text": "Exterior view of the property's modern building with a winding pathway and landscaping.",
        "public_id": "019d42aa-a676-70fa-9daf-d8a720ed8bbd",
        "storage_key": "property/6767906449166905/019d42aa-a676-70fa-9daf-d8a720ed8bbd.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Experience the welcoming exterior of our property, featuring modern architecture, lush landscaping, and a scenic pathway leading to the entrance.",
      "link": "false",
      "alt_text": "Exterior view of the property's modern building with a winding pathway and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_LeasingOfficeLandscaping.jpg"
    },
    {
      "id": "ec_9a153e670188a79932da8403",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4974-e4c7-77d9-b251-ac3f7729e855.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d4974-e4c7-77d9-b251-ac3f7729e855",
        "storage_key": "property/6767906449166905/019d4974-e4c7-77d9-b251-ac3f7729e855.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring private balconies and lush green spaces, perfect for outdoor enjoyment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_OriginalSideBuildingExteriorsLawn.jpg"
    },
    {
      "id": "ec_056afbbc13331790329f5888",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4974-d346-77ca-a2a8-28fab59ff75b.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and lush green lawns and a walking path.",
        "public_id": "019d4974-d346-77ca-a2a8-28fab59ff75b",
        "storage_key": "property/6767906449166905/019d4974-d346-77ca-a2a8-28fab59ff75b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex exterior featuring blue siding, balconies, well-kept landscaping, and a scenic walking path.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with balconies and lush green lawns and a walking path.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_OriginalSideDecksWalkway.jpg"
    },
    {
      "id": "ec_bd96778e4f55f9a2cfb04671",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4974-da34-75b4-a18a-08737fcdf80e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and parking lot",
        "public_id": "019d4974-da34-75b4-a18a-08737fcdf80e",
        "storage_key": "property/6767906449166905/019d4974-da34-75b4-a18a-08737fcdf80e.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building featuring blue siding, balconies, and a well-maintained parking lot with numbered spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with balconies and parking lot",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_OriginalSideUnderBuildingCarports.jpg"
    },
    {
      "id": "ec_ea8b99b7ad0cf0a424223b72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4974-d6bb-706b-a95a-db93981f2e22.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with dark gray siding and white trim.",
        "public_id": "019d4974-d6bb-706b-a95a-db93981f2e22",
        "storage_key": "property/6767906449166905/019d4974-d6bb-706b-a95a-db93981f2e22.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of a multifamily apartment building featuring dark gray siding, white trim, and lush landscaping, offering a welcoming approach to the residences.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily apartment building with dark gray siding and white trim.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_OriginalSideBuildingEntries.jpg"
    },
    {
      "id": "ec_4e346df04dcdd1cb9c2512e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4974-d346-77ca-a2a8-2dddb8f5ac3b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and trees.",
        "public_id": "019d4974-d346-77ca-a2a8-2dddb8f5ac3b",
        "storage_key": "property/6767906449166905/019d4974-d346-77ca-a2a8-2dddb8f5ac3b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming apartment buildings set against a backdrop of mature trees and vibrant green lawns. Offers a peaceful and inviting community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with lush green lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_NewSideExteriorEntries.jpg"
    },
    {
      "id": "ec_1b07b978561b0bc82640f4cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-00ed-74ef-8203-ffa611ccb9dd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings surrounded by lush trees and green grass.",
        "public_id": "019d4975-00ed-74ef-8203-ffa611ccb9dd",
        "storage_key": "property/6767906449166905/019d4975-00ed-74ef-8203-ffa611ccb9dd.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Experience the serene beauty of our community, featuring well-maintained grounds and apartment buildings nestled among mature trees.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings surrounded by lush trees and green grass.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_GreenSpaceTrees.jpg"
    },
    {
      "id": "ec_8a9956d1e911e9a62d4499a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-00e3-75f9-9bd2-064b43255301.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of garages with tan doors and blue siding.",
        "public_id": "019d4975-00e3-75f9-9bd2-064b43255301",
        "storage_key": "property/6767906449166905/019d4975-00e3-75f9-9bd2-064b43255301.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "A clean and well-maintained row of garages with tan doors and gray siding, set against a backdrop of lush green trees and a clear blue sky. Offers convenient parking and storage solutions.",
      "link": "false",
      "alt_text": "Exterior view of a row of garages with tan doors and blue siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Garages(1).jpg"
    },
    {
      "id": "ec_bea1ecf7cdd183318a77cedc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-090d-7417-95e1-ef03fda6d423.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight benches, and free weights.",
        "public_id": "019d4975-090d-7417-95e1-ef03fda6d423",
        "storage_key": "property/6767906449166905/019d4975-090d-7417-95e1-ef03fda6d423.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, ellipticals, stationary bikes, weight machines, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight benches, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_FitnessCenterEquipment.jpg"
    },
    {
      "id": "ec_698f760703b8c66e4deac14c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-072f-700a-b7c5-846a1b6aceca.webp",
      "image_media": {
        "alt_text": "Gym equipment including a punching bag, weight machines, and free weights.",
        "public_id": "019d4975-072f-700a-b7c5-846a1b6aceca",
        "storage_key": "property/6767906449166905/019d4975-072f-700a-b7c5-846a1b6aceca.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Stay active and fit in our fully equipped community gym, featuring a variety of cardio and strength training machines.",
      "link": "false",
      "alt_text": "Gym equipment including a punching bag, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_FitnessCenterMachines.jpg"
    },
    {
      "id": "ec_973fe7b5720ea33cb61a280b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-0d6c-7278-977b-0124d37d9af4.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weights, and exercise equipment.",
        "public_id": "019d4975-0d6c-7278-977b-0124d37d9af4",
        "storage_key": "property/6767906449166905/019d4975-0d6c-7278-977b-0124d37d9af4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio machines, free weights, and strength training equipment for your workout needs.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weights, and exercise equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_FitnessCenterFreeWeights.jpg"
    },
    {
      "id": "ec_892c7e6972cd42f7a71f315f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-360d-72e9-9526-f28327838bc2.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs, umbrellas and a playground in the background.",
        "public_id": "019d4975-360d-72e9-9526-f28327838bc2",
        "storage_key": "property/6767906449166905/019d4975-360d-72e9-9526-f28327838bc2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Enjoy the sunshine and take a refreshing dip.",
      "link": "false",
      "alt_text": "Swimming pool area with lounge chairs, umbrellas and a playground in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_SeasonalSwimmingPool.jpg"
    },
    {
      "id": "ec_35b5c53032b9c3f5fe838ce4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-33ee-7171-80d8-fb405b4ae99a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and playground at apartment complex.",
        "public_id": "019d4975-33ee-7171-80d8-fb405b4ae99a",
        "storage_key": "property/6767906449166905/019d4975-33ee-7171-80d8-fb405b4ae99a.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling pool or let the kids play at the on-site playground. Perfect for summer fun!",
      "link": "false",
      "alt_text": "Outdoor swimming pool and playground at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_SwimmingPoolBuildingExteriors.jpg"
    },
    {
      "id": "ec_f2d7f8f37bdb0a80c9b12292",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-39ef-719b-89c7-a3450638136b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and a playground in the background.",
        "public_id": "019d4975-39ef-719b-89c7-a3450638136b",
        "storage_key": "property/6767906449166905/019d4975-39ef-719b-89c7-a3450638136b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge seating and a fun playground for the kids.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and a playground in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_SeasonalSwimmingPoolDeckLounges.jpg"
    },
    {
      "id": "ec_7519d0673fc17f2a960ecfeb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-414d-7531-93dc-8d7ccaeeb70b.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings in front of apartment buildings",
        "public_id": "019d4975-414d-7531-93dc-8d7ccaeeb70b",
        "storage_key": "property/6767906449166905/019d4975-414d-7531-93dc-8d7ccaeeb70b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides, swings, and climbing structures perfect for children.",
      "link": "false",
      "alt_text": "Playground with slides and swings in front of apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Playground.jpg"
    },
    {
      "id": "ec_a780a4c110d2b1bc115f7f8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-466e-75f2-a3ab-6550849cfefa.webp",
      "image_media": {
        "alt_text": "Fenced dog park with wood chips, benches, and agility equipment.",
        "public_id": "019d4975-466e-75f2-a3ab-6550849cfefa",
        "storage_key": "property/6767906449166905/019d4975-466e-75f2-a3ab-6550849cfefa.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy our pet-friendly community with a dedicated dog park, perfect for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "Fenced dog park with wood chips, benches, and agility equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_BarkPark(1).jpg"
    },
    {
      "id": "ec_455cfa06dcd84556200c2ebd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-6104-735a-a62c-84d2d67e76fc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and stainless steel sink.",
        "public_id": "019d4975-6104-735a-a62c-84d2d67e76fc",
        "storage_key": "property/6767906449166905/019d4975-6104-735a-a62c-84d2d67e76fc.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring modern black appliances, ample white cabinetry, and a sleek stainless steel sink, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1Kitchen.jpg"
    },
    {
      "id": "ec_5c489333fb4bfe8fdd4aa8e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-6cb3-7329-85a3-30fea6c5920b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel sink, dishwasher, and black refrigerator.",
        "public_id": "019d4975-6cb3-7329-85a3-30fea6c5920b",
        "storage_key": "property/6767906449166905/019d4975-6cb3-7329-85a3-30fea6c5920b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, quartz countertops, a deep sink with a pull-down faucet, and a full suite of appliances including a dishwasher and refrigerator.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel sink, dishwasher, and black refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1KitchenDiningRoom.jpg"
    },
    {
      "id": "ec_0f40148fae72a0c9cc5b29b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-6d87-768d-b550-3761781c8014.webp",
      "image_media": {
        "alt_text": "Kitchen and living room in an apartment",
        "public_id": "019d4975-6d87-768d-b550-3761781c8014",
        "storage_key": "property/6767906449166905/019d4975-6d87-768d-b550-3761781c8014.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring white cabinets, a black refrigerator, and a sink, adjacent to a living room with carpet and a heating unit.",
      "link": "false",
      "alt_text": "Kitchen and living room in an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1KitchenLivingRoom.jpg"
    },
    {
      "id": "ec_556ecb530a6ca8abfe40baa1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-74e0-772f-88a0-fd1f7addc80c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with carpet and hardwood floors, white cabinets, and a refrigerator.",
        "public_id": "019d4975-74e0-772f-88a0-fd1f7addc80c",
        "storage_key": "property/6767906449166905/019d4975-74e0-772f-88a0-fd1f7addc80c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living area flowing into a functional kitchen. Features carpeted floors in the living space and elegant hardwood floors in the kitchen, complemented by white cabinetry and a stainless steel refrigerator.",
      "link": "false",
      "alt_text": "Living room and kitchen area with carpet and hardwood floors, white cabinets, and a refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1DiningRoomLivingRoom.jpg"
    },
    {
      "id": "ec_5ee38d0601a6a6d40ba23402",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-822f-7166-a268-8d3c5da589ee.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors leading to a balcony and view of trees.",
        "public_id": "019d4975-822f-7166-a268-8d3c5da589ee",
        "storage_key": "property/6767906449166905/019d4975-822f-7166-a268-8d3c5da589ee.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living room featuring plush carpeting and sliding glass doors that open to a private balcony with a scenic view of surrounding greenery. A ceiling fan is visible in the adjacent dining area.",
      "link": "false",
      "alt_text": "Living room with sliding glass doors leading to a balcony and view of trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1LivingRoomSlidingGlassDoor.jpg"
    },
    {
      "id": "ec_2dbee4e374de8c23e0d530da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-8c08-7299-a455-38a8365a8abc.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet, sliding glass doors, and balcony view",
        "public_id": "019d4975-8c08-7299-a455-38a8365a8abc",
        "storage_key": "property/6767906449166905/019d4975-8c08-7299-a455-38a8365a8abc.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living room with neutral carpet and large sliding glass doors that lead to a balcony with a lush green view.",
      "link": "false",
      "alt_text": "Empty living room with carpet, sliding glass doors, and balcony view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1LivingRoomDeck.jpg"
    },
    {
      "id": "ec_88bfad0bbc08d041a811e917",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-96e2-7342-8532-262de4234d36.webp",
      "image_media": {
        "alt_text": "Empty room with carpet, a window overlooking trees, and a heating unit.",
        "public_id": "019d4975-96e2-7342-8532-262de4234d36",
        "storage_key": "property/6767906449166905/019d4975-96e2-7342-8532-262de4234d36.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment living area with plush carpeting and a large window providing natural light.",
      "link": "false",
      "alt_text": "Empty room with carpet, a window overlooking trees, and a heating unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1Bedroom.jpg"
    },
    {
      "id": "ec_688add7035cd1fb2e2a34ce0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-9243-742a-93a8-09a065d95869.webp",
      "image_media": {
        "alt_text": "Bedroom with a large sliding door closet",
        "public_id": "019d4975-9243-742a-93a8-09a065d95869",
        "storage_key": "property/6767906449166905/019d4975-9243-742a-93a8-09a065d95869.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet with sliding doors for ample storage. Carpeted flooring and a bright, airy feel make this room comfortable and inviting.",
      "link": "false",
      "alt_text": "Bedroom with a large sliding door closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1BedroomCloset.jpg"
    },
    {
      "id": "ec_7329f0019a1a1407e2806f69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-96e7-75cc-8184-9509bfd16c82.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019d4975-96e7-75cc-8184-9509bfd16c82",
        "storage_key": "property/6767906449166905/019d4975-96e7-75cc-8184-9509bfd16c82.webp",
        "width": 1463,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a clean vanity with a sink, a toilet, and a shower/tub combination, perfect for your daily routine.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant1x1Bathroom.jpg"
    },
    {
      "id": "ec_05e2950ff3abfec942561a69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-a690-7664-8e0b-cb02c9b2c9f3.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, stove, and dark wood cabinets.",
        "public_id": "019d4975-a690-7664-8e0b-cb02c9b2c9f3",
        "storage_key": "property/6767906449166905/019d4975-a690-7664-8e0b-cb02c9b2c9f3.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring black appliances, dark wood cabinetry, granite countertops, and a stainless steel sink.",
      "link": "false",
      "alt_text": "Kitchen with black refrigerator, stove, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2Kitchen.jpg"
    },
    {
      "id": "ec_87c2cd9682506667f0d40a0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-b2ae-724d-8365-05bf57e5e4da.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room and kitchen area with neutral carpet and wood floors.",
        "public_id": "019d4975-b2ae-724d-8365-05bf57e5e4da",
        "storage_key": "property/6767906449166905/019d4975-b2ae-724d-8365-05bf57e5e4da.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment featuring a welcoming living area and a well-appointed kitchen. Perfect for creating your own home.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living room and kitchen area with neutral carpet and wood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2DiningRoomLivingRoom.jpg"
    },
    {
      "id": "ec_2b3d28823dd7e4ff919a8d22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-b3cc-70e9-9e43-8be8a93c613e.webp",
      "image_media": {
        "alt_text": "Interior view of a spacious living room with large windows and a sliding glass door leading to a balcony.",
        "public_id": "019d4975-b3cc-70e9-9e43-8be8a93c613e",
        "storage_key": "property/6767906449166905/019d4975-b3cc-70e9-9e43-8be8a93c613e.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this expansive apartment living room, featuring plush carpeting and abundant natural light streaming through large windows and a sliding glass door.",
      "link": "false",
      "alt_text": "Interior view of a spacious living room with large windows and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2LivingRoomDeck.jpg"
    },
    {
      "id": "ec_85056d55ce81dd2976a96c9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-bc66-732a-80ee-fb81fb8eb0ff.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with carpet, a window, and a door.",
        "public_id": "019d4975-bc66-732a-80ee-fb81fb8eb0ff",
        "storage_key": "property/6767906449166905/019d4975-bc66-732a-80ee-fb81fb8eb0ff.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious and carpeted living area in an apartment, featuring large windows for natural light and a convenient entrance door.",
      "link": "false",
      "alt_text": "Empty apartment living room with carpet, a window, and a door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2LivingRoomEntry.jpg"
    },
    {
      "id": "ec_93b273ee45c0439948d9d266",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-bfe6-768f-82f2-b72911a29fc4.webp",
      "image_media": {
        "alt_text": "Bedroom with vanity and closet",
        "public_id": "019d4975-bfe6-768f-82f2-b72911a29fc4",
        "storage_key": "property/6767906449166905/019d4975-bfe6-768f-82f2-b72911a29fc4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a vanity area with granite countertops and a large sliding door closet, perfect for storage.",
      "link": "false",
      "alt_text": "Bedroom with vanity and closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2PrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_7eca7821db17eb2111b7f601",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-ca7d-7268-9ba5-5eb86add5ba3.webp",
      "image_media": {
        "alt_text": "View into a half bathroom with a toilet from a bedroom.",
        "public_id": "019d4975-ca7d-7268-9ba5-5eb86add5ba3",
        "storage_key": "property/6767906449166905/019d4975-ca7d-7268-9ba5-5eb86add5ba3.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Step into this cozy apartment and discover the convenience of a private half bathroom, complete with a toilet for your ease. Enjoy the plush carpeting and bright, inviting atmosphere.",
      "link": "false",
      "alt_text": "View into a half bathroom with a toilet from a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2PrimaryBedroomEntry.jpg"
    },
    {
      "id": "ec_a0d1ef8a2c87f9a9b7c8168e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-daf1-73ab-aa5c-61826eacd028.webp",
      "image_media": {
        "alt_text": "View of a bedroom with a closet and window.",
        "public_id": "019d4975-daf1-73ab-aa5c-61826eacd028",
        "storage_key": "property/6767906449166905/019d4975-daf1-73ab-aa5c-61826eacd028.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom with ample closet space and a large window offering exterior views. This room provides a comfortable and bright living environment.",
      "link": "false",
      "alt_text": "View of a bedroom with a closet and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2SecondBedroom.jpg"
    },
    {
      "id": "ec_133b19799d179c9cf96c066b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-dc06-70cc-8755-23bb682b9872.webp",
      "image_media": {
        "alt_text": "Interior of a bedroom showing a large sliding door closet with white doors and shelving inside.",
        "public_id": "019d4975-dc06-70cc-8755-23bb682b9872",
        "storage_key": "property/6767906449166905/019d4975-dc06-70cc-8755-23bb682b9872.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious sliding door closet with ample shelving and hanging space, perfect for organizing your wardrobe and personal belongings.",
      "link": "false",
      "alt_text": "Interior of a bedroom showing a large sliding door closet with white doors and shelving inside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2ThirdBedroom.jpg"
    },
    {
      "id": "ec_d1e7b4d9c5fbaf204c32de70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-e18e-753a-ba64-87b0aac19c4b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, mirror, and toilet.",
        "public_id": "019d4975-e18e-753a-ba64-87b0aac19c4b",
        "storage_key": "property/6767906449166905/019d4975-e18e-753a-ba64-87b0aac19c4b.webp",
        "width": 1367,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity with a granite countertop, a large mirror with vanity lighting, and a toilet. The apartment bathroom offers ample storage space and a neutral color scheme.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2HallwayBathroom.jpg"
    },
    {
      "id": "ec_8370c336d452b92f16f1ac0a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d4975-ea72-70db-bf59-fdf841be1aee.webp",
      "image_media": {
        "alt_text": "View of lush green grounds and trees from a balcony at an apartment complex.",
        "public_id": "019d4975-ea72-70db-bf59-fdf841be1aee",
        "storage_key": "property/6767906449166905/019d4975-ea72-70db-bf59-fdf841be1aee.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy the beautiful grounds and mature trees from your private balcony, offering a serene and natural setting.",
      "link": "false",
      "alt_text": "View of lush green grounds and trees from a balcony at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ShadowHills_Portland_OR_Vacant3x2DeckView.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_184dd98c-d40d-4c85-816e-8c84b4cca0ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Raising Cane’s Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "700 SW 5th Ave #1109, Portland, OR 97204, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers, Texas toast, and Cane's sauce, and they praise the friendly and efficient service. They also highlight the great value for the price, with many mentioning the chicken fingers are some of the best they've ever had.\n\nSome reviews mention the lines can be long, especially during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-1885-7150-8632-d2f897765a3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1885-7150-8632-d2f897765a3e",
        "storage_key": "property/6767906449166905/019d08b0-1885-7150-8632-d2f897765a3e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/or/portland/700-sw-5th-st-1109",
      "poi_directions_map_url": "https://maps.google.com/?cid=12547526630509412446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "45.5175349",
      "poi_longitude": "-122.6778527",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-227-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-c98e-741c-917b-fc9c4a784ff3",
        "storage_key": "property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3PFivsLlVQRXoBEpf3EIa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_31ae348a-a4c1-4626-ad97-33d3c83884a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Eem - Thai BBQ & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "3808 N Williams Ave #127, Portland, OR 97227, USA",
      "poi_short_description": "Modern Thai eatery serving creative BBQ and craft cocktails including tiki drinks in traditional mugs.",
      "poi_long_description": "People say this Thai restaurant serves delicious white curry, brisket fried rice, and ceviche. They highlight the generous portion sizes, unique cocktails, and fun, lively atmosphere. They also like the friendly and welcoming service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-1866-746a-ac57-2fb492a4d7fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1866-746a-ac57-2fb492a4d7fd",
        "storage_key": "property/6767906449166905/019d08b0-1866-746a-ac57-2fb492a4d7fd.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "http://www.eempdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677422174665807613&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eem---thai-bbq--cocktails",
      "poi_latitude": "45.5506551",
      "poi_longitude": "-122.6665212",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 971-295-1645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-c98e-741c-917b-fc9c4a784ff3",
        "storage_key": "property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa08KlqnlVQR_ZZx1jEcTYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_3d7dac57-40ca-4f6b-9edc-f026334d4e05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Screen Door Pearl District",
      "poi_type": "Restaurants",
      "poi_address": "1131 NW Couch St, Portland, OR 97209, USA",
      "poi_short_description": "Well-lit, stylish destination with outdoor seating offering meals, beer, and cocktails.",
      "poi_long_description": "People say this Southern restaurant serves delicious chicken and waffles, cinnamon rolls, and Bananas Foster French Toast. They highlight the generous portions, flavorful dishes, and the quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-1603-7009-a1e7-05699c4bde9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1603-7009-a1e7-05699c4bde9f",
        "storage_key": "property/6767906449166905/019d08b0-1603-7009-a1e7-05699c4bde9f.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://screendoorrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2574505151415432726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "screen-door-pearl-district",
      "poi_latitude": "45.523796",
      "poi_longitude": "-122.6827051",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-542-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-c98e-741c-917b-fc9c4a784ff3",
        "storage_key": "property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLU7eCV0LlVQRFraHfst6uiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a8c2c303-346d-4a21-8161-881737c5b3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Luc Lac Vietnamese Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "835 SW 2nd Ave, Portland, OR 97204, USA",
      "poi_short_description": "Bustling counter-serve restaurant in a stylish setting serving pho, banh mi & other Vietnamese fare.",
      "poi_long_description": "People say this Vietnamese restaurant serves delicious coconut curry, vermicelli bowls, and pho. They highlight the vibrant and fun atmosphere, and the fast service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-1a51-70bf-936a-bbc7c52fd03d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1a51-70bf-936a-bbc7c52fd03d",
        "storage_key": "property/6767906449166905/019d08b0-1a51-70bf-936a-bbc7c52fd03d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.luclackitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11849354532108914595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "luc-lac-vietnamese-kitchen",
      "poi_latitude": "45.5168971",
      "poi_longitude": "-122.6754165",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-222-0047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-c98e-741c-917b-fc9c4a784ff3",
        "storage_key": "property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTJKdg8KlVQRo08EmCpdcaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_6d6bb864-251b-4b30-adb4-244956cfa3c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "930 SW 6th Ave, Portland, OR 97204, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "People say this Brazilian steakhouse offers a wide variety of meats, including picanha, filet mignon, and lamb, as well as a delicious salad bar with fresh vegetables, cheeses, and sides. They highlight the fun and lively atmosphere, and the attentive and friendly service. They also like the all-you-can-eat option and the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-1ecb-7381-9a9c-28266dd8681d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1ecb-7381-9a9c-28266dd8681d",
        "storage_key": "property/6767906449166905/019d08b0-1ecb-7381-9a9c-28266dd8681d.webp",
        "width": 1095,
        "height": 654
      },
      "poi_business_url": "https://fogodechao.com/brazil-cuts/?utm_source=sem&utm_medium=search&utm_campaign=evg&utm_id=lf-cnvrs&utm_term=brand&utm_content=bob&gclsrc=aw.ds&&utm_content=771480581692&mkwid=s&pcrid=771480581692&kw=fogo%20de%20chao&pmt=b&pdv=m&slid=&gad_source=1&gad_campaignid=22441774797&gbraid=0AAAAAok23aNqTgbAOwARMe3UpSaqRGEek&gclid=Cj0KCQjw9JLHBhC-ARIsAK4PhcrpT3UZzffs2tvvl9x7453QzsklEW_Gi4yv54fGDc2DhAY7XU30ETEaAjvMEALw_wcB",
      "poi_directions_map_url": "https://maps.google.com/?cid=17351528641511249354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "45.517218",
      "poi_longitude": "-122.6793081",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-241-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-c98e-741c-917b-fc9c4a784ff3",
        "storage_key": "property/6767906449166905/019d08af-c98e-741c-917b-fc9c4a784ff3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcKDSAUKlVQRylVL-10DzfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_430d798d-85ed-4df6-b5b2-6a5e426f6da1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Washington Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9585 SW Washington Square Rd, Portland, OR 97223, USA",
      "poi_short_description": "Large shopping center with a variety of department stores, specialty shops & food options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and services, including a Cheesecake Factory, a Lego store, and a variety of clothing stores. They also highlight the clean and well-maintained environment, the friendly and helpful staff, and the convenient parking.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-211a-76ec-aba2-ddc3dab10dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-211a-76ec-aba2-ddc3dab10dd5",
        "storage_key": "property/6767906449166905/019d08b0-211a-76ec-aba2-ddc3dab10dd5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopwashingtonsquare.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036230870585529003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-square",
      "poi_latitude": "45.4502491",
      "poi_longitude": "-122.7812183",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-639-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-ceab-77ce-bbae-9d3afad36a45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-ceab-77ce-bbae-9d3afad36a45",
        "storage_key": "property/6767906449166905/019d08af-ceab-77ce-bbae-9d3afad36a45.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9M2zVcMlVQRq1JHJmZthm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1a646327-a72b-4fb4-be3c-acd7e8d1103b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Powell's City of Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "1005 W Burnside St, Portland, OR 97209, USA",
      "poi_short_description": "Iconic bookseller offering a diverse selection of used & new volumes, plus gifts for bibliophiles.",
      "poi_long_description": "People say this bookstore offers a vast selection of new and used books, including a rare book room, and a variety of genres. They highlight the well-organized layout, the helpful staff, and the fun, immersive atmosphere. They also like the staff recommendations and the in-store cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-21a2-76eb-9271-65e6ba54af16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-21a2-76eb-9271-65e6ba54af16",
        "storage_key": "property/6767906449166905/019d08b0-21a2-76eb-9271-65e6ba54af16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.powells.com/locations/powells-city-of-books",
      "poi_directions_map_url": "https://maps.google.com/?cid=6978470595407941935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powells-city-of-books",
      "poi_latitude": "45.5232451",
      "poi_longitude": "-122.6814329",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-878-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-ceab-77ce-bbae-9d3afad36a45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-ceab-77ce-bbae-9d3afad36a45",
        "storage_key": "property/6767906449166905/019d08af-ceab-77ce-bbae-9d3afad36a45.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJByq0twMKlVQRL5HMcgiC2GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_6ca6423c-a691-40ba-9cd2-27718c28da3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Uwajimaya Beaverton",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, and Japanese groceries, including musubi, onigiri, and poke. They highlight the friendly and helpful staff, and the fun, unique shopping experience. They also like the bookstore in the back and the delicious hot food options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-232a-777e-a0fa-b151570c2679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-232a-777e-a0fa-b151570c2679",
        "storage_key": "property/6767906449166905/019d08b0-232a-777e-a0fa-b151570c2679.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/beaverton/?utm_source=localprofiles&utm_medium=organic&utm_content=beaverton&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570527899701517362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-beaverton",
      "poi_latitude": "45.48564529999999",
      "poi_longitude": "-122.7849074",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-643-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-ca3c-727d-9e76-885bbca16bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-ca3c-727d-9e76-885bbca16bc0",
        "storage_key": "property/6767906449166905/019d08af-ca3c-727d-9e76-885bbca16bc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVB9wAQMlVQRMpyACFA0L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_af47681b-c694-4be7-8133-1b66f858298f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4121 NE Halsey St, Portland, OR 97232, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of unique, tasty snacks, fresh produce, and vegan and vegetarian options. They highlight the affordable prices and the clean, well-stocked store. They also like the friendly and helpful staff, especially the cashiers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-266b-77d8-98ed-9ea4deeb1217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-266b-77d8-98ed-9ea4deeb1217",
        "storage_key": "property/6767906449166905/019d08b0-266b-77d8-98ed-9ea4deeb1217.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/or/portland/144/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3385217125696398999&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "45.5347161",
      "poi_longitude": "-122.6208153",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-284-4232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-ca3c-727d-9e76-885bbca16bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-ca3c-727d-9e76-885bbca16bc0",
        "storage_key": "property/6767906449166905/019d08af-ca3c-727d-9e76-885bbca16bc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzcJQHdqglVQRl-azSAq1-i4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a0e9ee8f-b48b-45ab-9226-e6ba2279a889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a movie theater. They also highlight the clean, beautiful, and open-air atmosphere, as well as the friendly staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-29f1-751a-b123-88e304a97113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-29f1-751a-b123-88e304a97113",
        "storage_key": "property/6767906449166905/019d08b0-29f1-751a-b123-88e304a97113.webp",
        "width": 1280,
        "height": 484
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-ceab-77ce-bbae-9d3afad36a45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-ceab-77ce-bbae-9d3afad36a45",
        "storage_key": "property/6767906449166905/019d08af-ceab-77ce-bbae-9d3afad36a45.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6e803975-ec15-4fdb-8a89-57d62914e0fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Lewis & Clark College",
      "poi_type": "Education",
      "poi_address": "615 S Palatine Hill Rd, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-6c1e-74b1-abbd-6eebd594d4db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-6c1e-74b1-abbd-6eebd594d4db",
        "storage_key": "property/6767906449166905/019d08af-6c1e-74b1-abbd-6eebd594d4db.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lclark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4013463715069943394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lewis--clark-college",
      "poi_latitude": "45.450223",
      "poi_longitude": "-122.670186",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-768-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d266-75da-9116-b4b4b8a70edb",
        "storage_key": "property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfSSk0DMLlVQRYt6pD_yvsjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b3b56332-4e64-47ff-80ee-c7653dacf561",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Portland Community College Sylvania",
      "poi_type": "Education",
      "poi_address": "12000 SW 49th Ave, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-b2fd-71fc-a6f0-e55eeb0a65ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-b2fd-71fc-a6f0-e55eeb0a65ad",
        "storage_key": "property/6767906449166905/019d08af-b2fd-71fc-a6f0-e55eeb0a65ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pcc.edu/about/locations/sylvania/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6662908794779881992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-community-college-sylvania",
      "poi_latitude": "45.4377659",
      "poi_longitude": "-122.7307089",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d266-75da-9116-b4b4b8a70edb",
        "storage_key": "property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUfp1OLoMlVQRCFKuSz9od1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7529adf5-baeb-4c7d-a1a5-c2bbda2f7a6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Portland State University",
      "poi_type": "Education",
      "poi_address": "1825 SW Broadway, Portland, OR 97201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-be9e-763f-9aef-3f0ba335f4c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-be9e-763f-9aef-3f0ba335f4c4",
        "storage_key": "property/6767906449166905/019d08af-be9e-763f-9aef-3f0ba335f4c4.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.pdx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3895283153264588693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-state-university",
      "poi_latitude": "45.5111153",
      "poi_longitude": "-122.6833385",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d266-75da-9116-b4b4b8a70edb",
        "storage_key": "property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkbAL-LGglVQRlTfmyWPTDjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_46dfb5cf-1523-43d0-be92-b35ba69d2eba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Reed College",
      "poi_type": "Education",
      "poi_address": "3203 SE Woodstock Blvd, Portland, OR 97202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-2e83-75f8-a1e0-27bc9878948a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-2e83-75f8-a1e0-27bc9878948a",
        "storage_key": "property/6767906449166905/019d08b0-2e83-75f8-a1e0-27bc9878948a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.reed.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5108961514061207608&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reed-college",
      "poi_latitude": "45.4810848",
      "poi_longitude": "-122.6308086",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-771-1112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d266-75da-9116-b4b4b8a70edb",
        "storage_key": "property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcwb3mKIKlVQROJjCuG2t5kY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1990f5fe-5421-42ad-8ffd-31c8698d9091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Beaverton City Library",
      "poi_type": "Education",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "People say this public library offers a wide selection of books, music CDs, DVDs/Blu-rays, and video games, as well as digital resources and a \"Library of Things.\" They highlight the spacious layout, beautiful architecture, and numerous working, studying, and reading spaces, including a dedicated children's area with storytime rooms. They also like the friendly and helpful staff, and the various activities and events for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3175-73ac-b077-489f1c875160.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3175-73ac-b077-489f1c875160",
        "storage_key": "property/6767906449166905/019d08b0-3175-73ac-b077-489f1c875160.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d266-75da-9116-b4b4b8a70edb",
        "storage_key": "property/6767906449166905/019d08af-d266-75da-9116-b4b4b8a70edb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4bfa19af-438a-43c0-a152-a8f4252c0a65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Moda Center",
      "poi_type": "Entertainment",
      "poi_address": "1 N Center Ct St, Portland, OR 97227, USA",
      "poi_short_description": "Entertainment complex housing the Portland Trail Blazers basketball & Winterhawks hockey teams.",
      "poi_long_description": "People say this arena offers a variety of events, including basketball games, concerts, and monster truck shows. They highlight the easy access, plentiful food and drink options, and the friendly and helpful staff. They also like the modern design, spacious seating, and clear acoustics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3159-772d-9e43-24f715f8f42d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3159-772d-9e43-24f715f8f42d",
        "storage_key": "property/6767906449166905/019d08b0-3159-772d-9e43-24f715f8f42d.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.rosequarter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12415760242401397159&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moda-center",
      "poi_latitude": "45.53156509999999",
      "poi_longitude": "-122.6668423",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-235-8771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfIK2VKnlVQRp8nAsCikTaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_b19cf5f1-1b74-4881-9c27-88a054d4e2fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Oregon Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4001 SW Canyon Rd, Portland, OR 97221, USA",
      "poi_short_description": "64-acre zoo featuring elephants, polar bears & other animal exhibits emphasizing conservation.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, polar bears, giraffes, and lions, and features a popular baby elephant. They highlight the well-maintained exhibits, the spacious and natural habitats, and the fun train ride. They also like the family-friendly atmosphere and the knowledgeable staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3362-724a-bcb4-ec4c3c57f247.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3362-724a-bcb4-ec4c3c57f247",
        "storage_key": "property/6767906449166905/019d08b0-3362-724a-bcb4-ec4c3c57f247.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oregonzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16710360885333195814&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-zoo",
      "poi_latitude": "45.5093572",
      "poi_longitude": "-122.714291",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-226-1561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbhWuC4KlVQRJvzdnrAg5-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_a3039a11-4a8e-4fd0-a096-01434588b6b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "OMSI",
      "poi_type": "Entertainment",
      "poi_address": "1945 SE Water Ave, Portland, OR 97214, USA",
      "poi_short_description": "Rotating shows, science labs, submarine tours & planetarium at a museum with monthly 21+ events.",
      "poi_long_description": "People say this museum offers a wide variety of interactive exhibits, including a dinosaur exhibit, a submarine tour, and a planetarium. They highlight the educational and family-friendly atmosphere, and the rotating exhibits that keep the experience fresh. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-7bd3-70be-aa00-6de7286c8edf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7bd3-70be-aa00-6de7286c8edf",
        "storage_key": "property/6767906449166905/019d08af-7bd3-70be-aa00-6de7286c8edf.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://omsi.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15020746415816767564&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "omsi",
      "poi_latitude": "45.5083931",
      "poi_longitude": "-122.6660355",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-797-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d3e2-729d-a6ea-fb111eb3fa1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d3e2-729d-a6ea-fb111eb3fa1d",
        "storage_key": "property/6767906449166905/019d08af-d3e2-729d-a6ea-fb111eb3fa1d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RKx6HIKlVQRTPj6J0hpdNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a87543ff-1d5d-4320-93aa-b2ae4e9c0730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Providence Park",
      "poi_type": "Entertainment",
      "poi_address": "1844 SW Morrison St, Portland, OR 97205, USA",
      "poi_short_description": "Sports & events venue with stadium & field hosting Major League Soccer, college football & more.",
      "poi_long_description": "Fans say this stadium offers an exciting atmosphere for soccer games and concerts, with a great selection of food and drinks, including local beers. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3824-719e-aae0-427b947c43fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3824-719e-aae0-427b947c43fa",
        "storage_key": "property/6767906449166905/019d08b0-3824-719e-aae0-427b947c43fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.timbers.com/providencepark?utm_source=Google%20Maps%20-%20Locl.io&utm_medium=Website%20Button&utm_campaign=Google%20Maps_Locl.io2019",
      "poi_directions_map_url": "https://maps.google.com/?cid=18429963036675327438&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-park",
      "poi_latitude": "45.521532",
      "poi_longitude": "-122.6917971",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-553-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-727d-719d-bb39-1433ff48d7a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-727d-719d-bb39-1433ff48d7a6",
        "storage_key": "property/6767906449166905/019d08b0-727d-719d-bb39-1433ff48d7a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2SA5mB0KlVQRzsWcWLxhxP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e79cc14c-c96d-4e4e-93c1-14de334e7149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Pittock Mansion",
      "poi_type": "Entertainment",
      "poi_address": "3229 NW Pittock Dr, Portland, OR 97210, USA",
      "poi_short_description": "23-room mansion from 1914 now a museum, featuring gardens, period furnishings & scenic views.",
      "poi_long_description": "People say this local history museum offers breathtaking views of the city and Mount Hood, and features a historic mansion with period furniture and decor. They highlight the beautifully maintained grounds, gardens, and hiking trails, and the informative self-guided tour. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3964-754d-b129-3426cea52d51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3964-754d-b129-3426cea52d51",
        "storage_key": "property/6767906449166905/019d08b0-3964-754d-b129-3426cea52d51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pittockmansion.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13828917755801354490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pittock-mansion",
      "poi_latitude": "45.5252061",
      "poi_longitude": "-122.7162689",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-823-3623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d3e2-729d-a6ea-fb111eb3fa1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d3e2-729d-a6ea-fb111eb3fa1d",
        "storage_key": "property/6767906449166905/019d08af-d3e2-729d-a6ea-fb111eb3fa1d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2_QC5IJlVQR-sChHm4v6r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_612b11a2-74c7-4b44-a085-83329b56c628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "600 SW 116th Ave, Portland, OR 97225, USA",
      "poi_short_description": "Athletic country club chain in Cedar Mill with a gym, an outdoor beach club, pools, basketball and pickleball courts, and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of classes, top-notch equipment, and multiple pools, including an adults-only option, and provides convenient amenities like a cafe, lounge, and clean locker rooms with saunas and plunge pools.\n\nOther reviews mention the price can be high and the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3ab5-7157-8c87-848740556033.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3ab5-7157-8c87-848740556033",
        "storage_key": "property/6767906449166905/019d08b0-3ab5-7157-8c87-848740556033.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/or/beaverton.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8291423413939196135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "45.5153662",
      "poi_longitude": "-122.7940413",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-616-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88xwwvQJlVQR59AzRqoNEXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_789c408f-b936-457e-ad3a-dc48a3948276",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "DoveLewis 24/7 Veterinary Emergency Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1945 NW Pettygrove St, Portland, OR 97209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-3e94-7462-8b4a-003009687399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-3e94-7462-8b4a-003009687399",
        "storage_key": "property/6767906449166905/019d08b0-3e94-7462-8b4a-003009687399.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://dovelewis.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2726875662202026056&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dovelewis-247-veterinary-emergency-hospital",
      "poi_latitude": "45.5330605",
      "poi_longitude": "-122.6913345",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-228-7281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC24DqfwJlVQRSLg1mPfO1yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9d6ad396-30d3-45f5-a4c0-342210cc1c41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8235 SW Apple Way, Portland, OR 97225, USA",
      "poi_short_description": "Large fitness center featuring ample cardio machines, tanning beds and hydro-massage loungers, plus clean showers.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including hack squat, vertical leg press, and four Smith machines, and most lockers already have locks. They highlight the spacious layout, clean facilities, and the availability of machines even during peak hours. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-40b7-7058-bef9-82e79af12b0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-40b7-7058-bef9-82e79af12b0d",
        "storage_key": "property/6767906449166905/019d08b0-40b7-7058-bef9-82e79af12b0d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/portland-raleigh-hills-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2165421477037240221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.4859322",
      "poi_longitude": "-122.7625921",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-477-4107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwYVFIqgLlVQRnW_OR1wfDR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eaa232ba-8347-4144-bc2a-ce7986dda208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 NW Northrup St, Portland, OR 97209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-4199-77f8-9a2b-c5c30bec3658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-4199-77f8-9a2b-c5c30bec3658",
        "storage_key": "property/6767906449166905/019d08b0-4199-77f8-9a2b-c5c30bec3658.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=438&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13281964386058845631&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.5313473",
      "poi_longitude": "-122.6856877",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-928-8892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1RJXQfwJlVQRvz1t_jwEU7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_769a9de2-7676-4ab2-92ec-bc274c7ca509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1210 NW Johnson St, Portland, OR 97209, USA",
      "poi_short_description": "Chain fitness center with cardio and strength-training equipment, plus a basketball court, a pool, and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-47f6-76dc-a00f-c526c684a28a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-47f6-76dc-a00f-c526c684a28a",
        "storage_key": "property/6767906449166905/019d08b0-47f6-76dc-a00f-c526c684a28a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/portland-or/the-pearl-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17097838413160430008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.52819059999999",
      "poi_longitude": "-122.6837269",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-222-1210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJExMN5_4JlVQRuLl003K5R-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e68cc497-5057-4fac-90cf-2fc6628ef7a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Lloyd Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "815 NE Halsey St Suite B Studio 1, Portland, OR 97232, USA",
      "poi_short_description": "Fun-focused gym offering a range of classes for all abilities, modern machines & an on-site bar.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including racquetball courts, specialty workout rooms, and a sauna, steam room, and hot tub. They highlight the affordable membership prices, the spacious layout, and the friendly, welcoming atmosphere. They also like the helpful and supportive staff, and the sense of community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-49df-73a2-a8ff-aef019ccab02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-49df-73a2-a8ff-aef019ccab02",
        "storage_key": "property/6767906449166905/019d08b0-49df-73a2-a8ff-aef019ccab02.webp",
        "width": 1040,
        "height": 1040
      },
      "poi_business_url": "http://www.lloydathleticclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15869144583854105189&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lloyd-athletic-club",
      "poi_latitude": "45.5340972",
      "poi_longitude": "-122.6568922",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-287-4594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDaFWq0ynlVQRZSLwseuGOtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3c50566f-9b69-482a-a0eb-9c5d0e0d7f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "OHSU Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3181 SW Sam Jackson Park Rd, Portland, OR 97239, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-b2fd-71fc-a6f0-ea9166a79169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-b2fd-71fc-a6f0-ea9166a79169",
        "storage_key": "property/6767906449166905/019d08af-b2fd-71fc-a6f0-ea9166a79169.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.ohsu.edu/visit/ohsu-hospital-portland?utm_source=gmb&utm_medium=organic&utm_content=LocationHospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15363967688716245467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohsu-hospital",
      "poi_latitude": "45.4992756",
      "poi_longitude": "-122.684882",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-494-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d94e-7278-b0d5-55ff0f3f6191.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d94e-7278-b0d5-55ff0f3f6191",
        "storage_key": "property/6767906449166905/019d08af-d94e-7278-b0d5-55ff0f3f6191.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ766_OkQKlVQR29mCCjbHN9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5cc5d352-d60d-46a2-bf3d-bd91cb662ea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Providence Portland Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4805 NE Glisan St, Portland, OR 97213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-4e82-7578-a420-8247cc407c57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-4e82-7578-a420-8247cc407c57",
        "storage_key": "property/6767906449166905/019d08b0-4e82-7578-a420-8247cc407c57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/portland-medical-center?ls=location&y_source=1_OTU3NjMxMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8840160028011374348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-portland-medical-center",
      "poi_latitude": "45.5276127",
      "poi_longitude": "-122.6132407",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-215-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d94e-7278-b0d5-55ff0f3f6191.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d94e-7278-b0d5-55ff0f3f6191",
        "storage_key": "property/6767906449166905/019d08af-d94e-7278-b0d5-55ff0f3f6191.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4vG892glVQRDKc5U7WOrno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5d59e3a1-30d5-4e48-bf6f-9fd605ebeeaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Portland Japanese Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "611 SW Kingston Ave, Portland, OR 97205, USA",
      "poi_short_description": "Many styles of gardens showcased in serene 5.5-acre space with waterfall, teahouse & mountain view.",
      "poi_long_description": "People say this garden offers stunning scenery, beautiful bonsai, and a peaceful atmosphere. They highlight the relaxing and serene vibe, and the well-maintained grounds with water features, koi ponds, and a waterfall. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-8515-72ad-a872-fce8ae424ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8515-72ad-a872-fce8ae424ecb",
        "storage_key": "property/6767906449166905/019d08af-8515-72ad-a872-fce8ae424ecb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://japanesegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11424717693547273965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-japanese-garden",
      "poi_latitude": "45.5188634",
      "poi_longitude": "-122.7080354",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-223-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d472-7437-a0f5-7a5adbdb5659",
        "storage_key": "property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJecbtFYoJlVQR7V4BJzbAjJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_7980eaf1-119e-4051-8dc3-993163383654",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "International Rose Test Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 SW Kingston Ave, Portland, OR 97205, USA",
      "poi_short_description": "City-maintained rose test gardens founded in 1917, featuring 10,000+ plants in manicured displays.",
      "poi_long_description": "People say this garden offers a stunning variety of roses, with vibrant colors and intoxicating fragrances. They highlight the peaceful and serene atmosphere, and the beautiful views of the city and mountains. They also like the free admission and the availability of a free shuttle. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-4fd8-738e-b141-69c93ed35b0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-4fd8-738e-b141-69c93ed35b0d",
        "storage_key": "property/6767906449166905/019d08b0-4fd8-738e-b141-69c93ed35b0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portland.gov/parks/washington-park-international-rose-test-garden",
      "poi_directions_map_url": "https://maps.google.com/?cid=10519281268788551622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "international-rose-test-garden",
      "poi_latitude": "45.5189524",
      "poi_longitude": "-122.7052686",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-823-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d472-7437-a0f5-7a5adbdb5659",
        "storage_key": "property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfarJiIoJlVQRxt-PlpT--5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_9be589f2-faec-4631-ae77-7302df0f7cf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Pioneer Courthouse Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 SW 6th Ave, Portland, OR 97204, USA",
      "poi_short_description": "Called the city's \"living room,\" this plaza is set beside an 1875 courthouse & hosts regular events.",
      "poi_long_description": "People say this city park offers a variety of events, festivals, and live music, and is a great place for people watching and relaxing. They also highlight the fun, lively atmosphere, and the convenient access to food carts, coffee shops, and public transportation.\n\nOther reviews mention the crowd can be large.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-514d-75af-861c-0c8ed962f5c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-514d-75af-861c-0c8ed962f5c2",
        "storage_key": "property/6767906449166905/019d08b0-514d-75af-861c-0c8ed962f5c2.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://thesquarepdx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18355606501016238535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-courthouse-square",
      "poi_latitude": "45.5188944",
      "poi_longitude": "-122.6793265",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-223-1613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d472-7437-a0f5-7a5adbdb5659",
        "storage_key": "property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz5wHQUKlVQRx3nsSdw2vP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a8c53c4d-bf89-4d8c-bd70-49effba566a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Laurelhurst Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SE Cesar E Chavez Blvd & Stark St, Portland, OR 97214, USA",
      "poi_short_description": "32-acre park featuring an off-leash dog area & a duck pond, plus walking trails & picnic areas.",
      "poi_long_description": "People say this park offers a duck pond, off-leash dog area, playground, and walking paths. They highlight the peaceful and beautiful atmosphere, and the large, old trees. They also like the picnic areas, sports courts, and wheelchair-accessible restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-518b-7497-a82c-8a9e28dda7af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-518b-7497-a82c-8a9e28dda7af",
        "storage_key": "property/6767906449166905/019d08b0-518b-7497-a82c-8a9e28dda7af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portland.gov/parks/laurelhurst-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11704282819391718750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "laurelhurst-park",
      "poi_latitude": "45.5211073",
      "poi_longitude": "-122.6272194",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-823-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d472-7437-a0f5-7a5adbdb5659",
        "storage_key": "property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbTuxOqglVQRXgWNWDb3baI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a1cf85e6-eba7-4948-bd47-e30a71dd6610",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Mt. Tabor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SE 60th Ave &, SE Salmon St, Portland, OR 97215, USA",
      "poi_short_description": "Large forested park covering an extinct volcano with tennis courts, a playground & 360-degree views.",
      "poi_long_description": "Visitors say this park offers stunning city views, a variety of hiking trails, and peaceful reservoirs perfect for picnics. They also highlight the family-friendly atmosphere with playgrounds and dog parks, and the opportunity to reconnect with nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-5610-7076-bb42-f97eb57ad598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-5610-7076-bb42-f97eb57ad598",
        "storage_key": "property/6767906449166905/019d08b0-5610-7076-bb42-f97eb57ad598.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portland.gov/parks/mt-tabor-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13338131880021385290&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mt-tabor-park",
      "poi_latitude": "45.5112549",
      "poi_longitude": "-122.5958201",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 503-823-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-d472-7437-a0f5-7a5adbdb5659",
        "storage_key": "property/6767906449166905/019d08af-d472-7437-a0f5-7a5adbdb5659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVdWgfiglVQRSuD8w0aQGrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_92b096dd-fcdd-472f-a94b-2e7b604428f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Portland Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 NW 6th Ave, Portland, OR 97209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-57af-7024-8c2c-cb8fb6bd88ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-57af-7024-8c2c-cb8fb6bd88ef",
        "storage_key": "property/6767906449166905/019d08b0-57af-7024-8c2c-cb8fb6bd88ef.webp",
        "width": 914,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=PDX",
      "poi_directions_map_url": "https://maps.google.com/?cid=16883121867529895098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-union-station",
      "poi_latitude": "45.5290829",
      "poi_longitude": "-122.6767744",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-743f-749d-acc1-795ec5ce256d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-743f-749d-acc1-795ec5ce256d",
        "storage_key": "property/6767906449166905/019d08b0-743f-749d-acc1-795ec5ce256d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YQlXlWnlVQRury_TePlTOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_61a6b678-cfde-427f-b61a-1e7293970cf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Beaverton TC MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-5928-74bc-9284-435e2f8a1d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-5928-74bc-9284-435e2f8a1d03",
        "storage_key": "property/6767906449166905/019d08b0-5928-74bc-9284-435e2f8a1d03.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9821",
      "poi_directions_map_url": "https://maps.google.com/?cid=13913915888813031590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-tc-max-station",
      "poi_latitude": "45.4914575",
      "poi_longitude": "-122.8016546",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ7Mt6YOlVQRpkBdI8goGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_34ff0a54-470b-4550-abb0-3e0e4c1a0b66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Rose Quarter Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "NE Holladay St, Portland, OR 97232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-5a64-77e8-9383-90e3514a709d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-5a64-77e8-9383-90e3514a709d",
        "storage_key": "property/6767906449166905/019d08b0-5a64-77e8-9383-90e3514a709d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12417676673154328490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-quarter-transit-center",
      "poi_latitude": "45.5301346",
      "poi_longitude": "-122.6652481",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMV0836yglVQRqqcEfyRzVKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f4ab008d-df98-47ed-96ff-c3e899fe8b7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Hollywood/NE 42nd Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-5e61-7407-a011-6e12741d9cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-5e61-7407-a011-6e12741d9cb3",
        "storage_key": "property/6767906449166905/019d08b0-5e61-7407-a011-6e12741d9cb3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369506379827086600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hollywoodne-42nd-ave",
      "poi_latitude": "45.53289789999999",
      "poi_longitude": "-122.6211344",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbG8M9qglVQRCIW9yRzj548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a73449cb-132d-41bd-8b22-fc98d5fea6c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "PSU Urban Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-6067-720a-9e56-975b4686db0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-6067-720a-9e56-975b4686db0c",
        "storage_key": "property/6767906449166905/019d08b0-6067-720a-9e56-975b4686db0c.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://trimet.org/#tracker/stop/10764",
      "poi_directions_map_url": "https://maps.google.com/?cid=834252715071957722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "psu-urban-center",
      "poi_latitude": "45.51222",
      "poi_longitude": "-122.682078",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_XoLxEKlVQR2urEnmzckws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_cdfcb9e8-526e-4003-a015-1cf2b5eaa3d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Daimler Truck North America (TEC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "TEC, 4747 N Channel Ave, Portland, OR 97217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-61aa-701a-aa3a-46da3b42fab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-61aa-701a-aa3a-46da3b42fab5",
        "storage_key": "property/6767906449166905/019d08b0-61aa-701a-aa3a-46da3b42fab5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://northamerica.daimlertruck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12085477051079676782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daimler-truck-north-america-tec",
      "poi_latitude": "45.5564842",
      "poi_longitude": "-122.7057232",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-745-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-eUknunlVQRblO9qlg9uKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5d4428d0-3509-494d-97fb-7b0798d2c744",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "adidas Corporate Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5077 N Greeley Ave, Portland, OR 97217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-62dd-702e-a499-1722ab7ed5e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-62dd-702e-a499-1722ab7ed5e2",
        "storage_key": "property/6767906449166905/019d08b0-62dd-702e-a499-1722ab7ed5e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adidas-group.com/en/about/headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=17954879087984317181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adidas-corporate-offices",
      "poi_latitude": "45.560097",
      "poi_longitude": "-122.6945599",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-982-9337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6sRJHenlVQR_RJlyGaLLPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6d41447f-81ca-4237-b862-0d41179178e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "Daimler Truck North America LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Daimler Truck HQ, 4555 N Channel Ave, Portland, OR 97217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-670f-779f-8a36-91fcf82a3ef0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-670f-779f-8a36-91fcf82a3ef0",
        "storage_key": "property/6767906449166905/019d08b0-670f-779f-8a36-91fcf82a3ef0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://northamerica.daimlertruck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12081766110094186165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daimler-truck-north-america-llc",
      "poi_latitude": "45.5553517",
      "poi_longitude": "-122.7028106",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-745-7124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsyUX-Y2nlVQRtVaE40MOq6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2df1e617-2022-4e72-aae9-6c58d4ca4a59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "AWS Elemental (PDX13)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1320 SW Broadway #400, Portland, OR 97201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12779097230135987545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aws-elemental-pdx13",
      "poi_latitude": "45.5148856",
      "poi_longitude": "-122.6814735",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-222-3212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVQ2NMwLlVQRWQ1vaDl5WLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5302ab24-4f82-43fb-9936-1720abfe03ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "poi_name": "911 Federal Building GSA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "911 NE 11th Ave, Portland, OR 97232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08b0-6909-744c-94cf-3709bc7d3f23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-6909-744c-94cf-3709bc7d3f23",
        "storage_key": "property/6767906449166905/019d08b0-6909-744c-94cf-3709bc7d3f23.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.gsa.gov/photos/portland-911-federal-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=16400229086601803467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "911-federal-building-gsa",
      "poi_latitude": "45.529386",
      "poi_longitude": "-122.6556162",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-cf09-74ef-b995-38c7601ab004",
        "storage_key": "property/6767906449166905/019d08af-cf09-74ef-b995-38c7601ab004.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0W6PoqhlVQRy_btTXZRmeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_303518b5-97fe-4af6-a6e9-f40b431839e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_2d39dd73-e478-450d-a2d5-964a78ba2d06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8ce2899e-602e-46d3-b819-65f182643308",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_1c4f99c1-f8b3-4e51-8405-f7bae8fbbb2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_91d7b552-b073-4175-bea4-3ac29cc9ea75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_c61f2a60-557e-4474-9910-047ae446895c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_10e98f9b-ee1e-4793-8204-3521e9898fd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_fdf2063e-7f14-410e-b25e-ee552e628c56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "rating": "5.0",
      "name": "D C",
      "text": "Just want to give a shout out to Casey and his team. The management is wonderful. We had to move out due to certain tenants, but that is outside of the property managments control. The complex is quiet and well maintained.",
      "date": "2025-09-05",
      "title": ""
    },
    {
      "id": "custom_dee13b54-e50b-4d50-afff-a599d965af1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "rating": "5.0",
      "name": "Molly Frechette",
      "text": "We have been at Shadow Hills for almost 2 years and are so lucky to have found such a great property. The staff is great to work with and they are always in communication with us if we need anything. Maintenance is prompt and takes care of everything within 48 hours of any request. Moving from a house, finding this property has made apartment life bearable for us.\n\nEdit:\n\nThe staff has been amazing during Covid-19 precautions and closures, giving clear communication and offering resources regularly. We are looking forward to when this is all over and we can become a physically closer knit community, because this pandemic has really brought this community together and I have loved getting to know the amazing neighbors around me in these strange times.",
      "date": "2020-04-30",
      "title": ""
    },
    {
      "id": "custom_eac7778f-f69f-458f-b7d9-fda3422ac426",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "rating": "5.0",
      "name": "Zena Kanes",
      "text": "The location and property is pretty unbeatable. Easy access to the freeway and grocery stores in walking distance. Gorgeous willow trees and well maintained landscape makes everything feel so serene. Management is friendly, responsive and on top of maintenance requests. We had ant problem and spider problem, but they were able to send a pest control company to deal with it free of charge. Definitely a dog and kid-friendly option.",
      "date": "2021-05-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a21e4810-ca2e-4d63-aab5-620d0e470a59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d313b-4235-7534-8d5b-1f861eb20126.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d313b-4235-7534-8d5b-1f861eb20126",
        "storage_key": "property/6767906449166905/019d313b-4235-7534-8d5b-1f861eb20126.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Shadow Hills Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Y9aQ8E5o7qE"
    },
    {
      "id": "custom_3f5e6dda-ec60-4891-9d25-3d36b7eb971f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d313c-efec-74c5-8e02-beae8c9dfa88.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d313c-efec-74c5-8e02-beae8c9dfa88",
        "storage_key": "property/6767906449166905/019d313c-efec-74c5-8e02-beae8c9dfa88.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Shadow Hills Apartments - 3 Bedroom 2 Bath 1170 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FL7kvYJWyV2"
    },
    {
      "id": "custom_d695bb14-2195-41ac-8a54-6e53ee869191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d313d-0578-74b9-9561-a964870bc10a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d313d-0578-74b9-9561-a964870bc10a",
        "storage_key": "property/6767906449166905/019d313d-0578-74b9-9561-a964870bc10a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Shadow Hills Apartments - 2 Bedroom 2 Bath 1000 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rmDSLRZvXmt"
    },
    {
      "id": "custom_cd5cd40a-9099-4b47-a910-13e71b294cf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166905/019d313d-ba1d-7458-802d-ca3d30752471.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d313d-ba1d-7458-802d-ca3d30752471",
        "storage_key": "property/6767906449166905/019d313d-ba1d-7458-802d-ca3d30752471.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Shadow Hills Apartments - 1 Bedroom 1 Bath 750 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6dV4tDpJ5VP"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1c2-3666-743a-ba0d-e5cd6f0a2e7e",
      "lead_source": "LANDING_PAGE",
      "name": "Shadow Hills Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "fitness-apartments-southwest-portland",
      "search_query": "apartments with fitness center in Southwest Portland",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Access",
      "h2_subtitle": "Discover Shadow Hills apartments with a 24-hour fitness center in Southwest Portland. Experience unmatched convenience and comfort in a vibrant community.",
      "page_copy": "At Shadow Hills, our residents relish the convenience of a state-of-the-art, 24-hour fitness center right on the premises. Nestled in the heart of Southwest Portland, our community offers well-equipped facilities designed to support your active lifestyle without needing to leave home. Just footsteps from your door, you'll find everything you need for a full workout session or a quick cardio rush.\n\nLocated in Multnomah County, Shadow Hills is more than just a home; it's a lifestyle filled with modern amenities like a bark park, sauna, and even covered parking. The on-site clubhouse, fitted with complimentary Wi-Fi, provides an ideal spot to unwind or catch up on some work. Embrace a community that combines luxury and practicality in one of the most desirable neighborhoods in Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Southwest Portland",
      "seo_description": "Experience Shadow Hills, featuring a 24-hour fitness center in Southwest Portland—a perfect blend of convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "pet-friendly-bark-park-multnomah",
      "search_query": "pet-friendly apartments with bark park Multnomah County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Bark Park",
      "h2_subtitle": "Discover Shadow Hills, offering pet-friendly living with a bark park in Multnomah County. Perfect for you and your furry friends to call home.",
      "page_copy": "Shadow Hills welcomes you and your pets to our vibrant community in Multnomah County. Our pet-friendly apartments come with a fantastic bark park, ensuring your four-legged companions have ample space to run, play, and socialize. Nestled in Southwest Portland, our residences provide a haven for pet owners and their furry friends.\n\nBeyond our delightful bark park, Shadow Hills offers premier amenities like a sauna, covered parking, and a clubhouse with complimentary Wi-Fi. Our 24-hour fitness center lets you maintain an active lifestyle, while our serene setting provides the tranquility you seek. Located in the heart of Multnomah County, our community ensures a joyful living experience for both you and your pets.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Bark Park, Multnomah",
      "seo_description": "Enjoy pet-friendly living at Shadow Hills in Multnomah County, complete with a bark park and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "swimming-pool-apartments-portland-or",
      "search_query": "apartments with swimming pool Portland OR",
      "category": "Amenity",
      "h1_title": "Portland OR Apartments with Amenities",
      "h2_subtitle": "While Shadow Hills doesn't have a swimming pool, our Portland OR apartments offer superior amenities, enhancing your lifestyle with modern comforts.",
      "page_copy": "In the vibrant city of Portland, OR, Shadow Hills offers an apartment living experience enriched with top-tier amenities. While we may not feature a swimming pool, our community makes up for it with a wide array of facilities, ensuring our residents enjoy the best of modern conveniences. From our 24-hour fitness center to the relaxing sauna, there's something for everyone.\n\nLocated in the desirable Southwest Portland area, Shadow Hills lives up to your expectations with pet-friendly spaces including a delightful bark park, and practical features such as covered parking. Our clubhouse, offering complimentary Wi-Fi, is an ideal spot to socialize or unwind. Explore the genuine comforts and community spirit at Shadow Hills, and discover why it's the perfect place to call home in Portland, OR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Portland OR Apartments with Modern Amenities",
      "seo_description": "Explore apartment living at Shadow Hills in Portland OR, offering modern amenities and a welcoming environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "covered-parking-apartments-97219",
      "search_query": "covered parking apartments in 97219",
      "category": "Amenity",
      "h1_title": "97219 Apartments with Covered Parking",
      "h2_subtitle": "Shadow Hills offers convenient covered parking in the 97219 area. Experience easy and secure parking at our Southwest Portland community.",
      "page_copy": "Shadow Hills in the heart of Portland's 97219 area, offers the ease and security of covered parking as part of our suite of desirable features. Our beautifully appointed apartments provide not just a place to live but a lifestyle enhanced by convenience and safety, ensuring that your vehicle is well-protected from the elements.\n\nOur Southwest Portland location ensures you're close to city amenities while enjoying the tranquility of a residential community. Along with covered parking, Shadow Hills offers other standout perks, including a bark park, 24-hour fitness center, sauna, and a clubhouse with complimentary Wi-Fi. Experience a fulfilling life in a community that combines convenience with luxury right here in the 97219 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Covered Parking Apartments in 97219",
      "seo_description": "Discover the convenience of covered parking at Shadow Hills in the 97219 area, providing secure and easy access in Southwest Portland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "clubhouse-wi-fi-southwest-portland",
      "search_query": "clubhouse with Wi-Fi in Southwest Portland apartments",
      "category": "Amenity",
      "h1_title": "Clubhouse with Wi-Fi in Southwest Portland",
      "h2_subtitle": "Enjoy a clubhouse with complimentary Wi-Fi in our Southwest Portland apartments. Shadow Hills offers this and more for a complete lifestyle experience.",
      "page_copy": "At Shadow Hills, located in the charming neighborhood of Southwest Portland, residents enjoy access to a clubhouse equipped with complimentary Wi-Fi. This amenity is ideal for those who wish to mix relaxation with work or social time. Whether you're catching up on work, streaming your favorite shows, or connecting with friends, our clubhouse offers a comfortable and connected environment.\n\nIn addition to our Wi-Fi-enabled clubhouse, Shadow Hills provides a range of amenities to enhance your living experience. Residents can benefit from our bark park, sauna, covered parking, and 24-hour fitness center. Our community is designed to meet diverse lifestyle needs, making it the perfect choice for those seeking both leisure and convenience in Southwest Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse with Wi-Fi: Southwest Portland Living",
      "seo_description": "Explore Shadow Hills in Southwest Portland, offering a clubhouse with complimentary Wi-Fi and various amenities for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-southwest-portland",
      "search_query": "one bedroom apartments southwest portland",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Southwest Portland",
      "h2_subtitle": "Discover comfortable one bedroom apartments at Shadow Hills, nestled in beautiful Southwest Portland. Enjoy a lifestyle of convenience and community.",
      "page_copy": "Shadow Hills offers beautifully designed one bedroom apartments in the heart of Southwest Portland. Perfectly situated in a vibrant community, our apartments provide a blend of comfort and modern living, making them an ideal choice for singles and couples alike. Each one-bedroom unit is tastefully appointed, providing a perfect space to call home.\n\nResidents of Shadow Hills benefit not just from stylish interiors but also from a suite of exceptional amenities. Enjoy a bark park for your furry friends, a rejuvenating sauna, and a 24-hour fitness center right at your doorstep. Our Southwest Portland property also features a clubhouse with complimentary Wi-Fi, ideal for working remotely or connecting with neighbors. Choose Shadow Hills for a one-bedroom apartment that offers the best in community and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Southwest Portland",
      "seo_description": "Explore one bedroom apartments at Shadow Hills in Southwest Portland, offering modern amenities and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-multnomah-county",
      "search_query": "two bedroom apartments multnomah county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Multnomah County",
      "h2_subtitle": "Shadow Hills offers spacious two bedroom apartments in Multnomah County. Enjoy premium amenities and a welcoming community atmosphere.",
      "page_copy": "Shadow Hills Apartments feature generously sized two bedroom units located in the heart of Multnomah County. Perfect for families or roommates, our two bedroom layouts combine comfort and style, allowing you to live and thrive in a modern setting. Each apartment is designed with ample living space, ensuring you have the room you need to unwind and entertain.\n\nBeyond your apartment door, Shadow Hills offers a range of amenities designed to enhance your lifestyle. Enjoy the convenience of covered parking, take advantage of our 24-hour fitness center, and relax in our clubhouse with complimentary Wi-Fi. Our community also boasts a bark park for pet lovers and a sauna for ultimate relaxation. Experience the best of Multnomah County living at Shadow Hills.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Multnomah County",
      "seo_description": "Discover spacious two bedroom apartments at Shadow Hills in Multnomah County, featuring modern amenities and comfortable living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-portland-or-97219",
      "search_query": "three bedroom apartments portland or 97219",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Portland, OR 97219",
      "h2_subtitle": "Discover spacious three bedroom apartments at Shadow Hills in Portland, OR 97219. Enjoy comfort and convenience in a prime location.",
      "page_copy": "Shadow Hills proudly offers expansive three bedroom apartments in the vibrant area of Portland, OR 97219. Designed with families and larger household needs in mind, these apartments provide ample living space and modern amenities, making them ideal for those seeking both style and functionality. Each unit is thoughtfully crafted to offer a harmonious blend of comfort and practicality.\n\nOur residents enjoy an impressive array of community amenities that complement the living experience at Shadow Hills. Take part in fitness routines at our 24-hour fitness center, or relax in our clubhouse featuring complimentary Wi-Fi. Additionally, our bark park offers a fantastic space for pet owners, and covered parking ensures your convenience. Discover the ideal living environment and community at Shadow Hills.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Portland, OR 97219",
      "seo_description": "Explore three bedroom apartments at Shadow Hills in Portland, OR 97219, offering ample space and modern amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-near-lewis-clark-college-portland",
      "search_query": "apartments near lewis & clark college portland",
      "category": "School",
      "h1_title": "Apartments Near Lewis & Clark College",
      "h2_subtitle": "Find the perfect apartment near Lewis & Clark College at Shadow Hills. Enjoy convenient access and community-focused living in Portland.",
      "page_copy": "Located just a short drive from Lewis & Clark College, Shadow Hills offers a variety of comfortable apartment living options perfect for students, faculty, and staff. Our community is situated in Southwest Portland, providing not only a close proximity to the college but also the vibrant culture and amenities of the area. Whether you need a relaxing retreat after a day of classes or a quiet place to study, Shadow Hills has you covered.\n\nOur residents enjoy high-quality amenities that enhance their living experience. From a clubhouse featuring complimentary Wi-Fi—ideal for studying or group projects—to a 24-hour fitness center and a relaxing sauna, there's something for everyone. The convenience of covered parking and the fun of a bark park are just the icing on the cake. Live close to campus without sacrificing the comforts of home at Shadow Hills.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewis & Clark College",
      "seo_description": "Discover apartments near Lewis & Clark College at Shadow Hills in Portland, offering convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-close-to-portland-community-college-sylvania",
      "search_query": "apartments close to portland community college sylvania",
      "category": "School",
      "h1_title": "Apartments Near PCC Sylvania Campus",
      "h2_subtitle": "Explore convenient living at Shadow Hills, just minutes from the Sylvania Campus of Portland Community College. Ideal for students and faculty.",
      "page_copy": "Shadow Hills provides the perfect home for those looking to live close to Portland Community College's Sylvania Campus. Our apartments offer a blend of comfort and convenience, tailored to meet the needs of students and faculty alike. Located in the welcoming neighborhood of Southwest Portland, Shadow Hills is an ideal choice for those seeking a quick and easy commute to campus.\n\nBeyond proximity, you'll find an array of amenities that make Shadow Hills a standout community. Unwind after classes in our sauna, keep fit with our 24-hour fitness center, or get some work done with complimentary Wi-Fi in our clubhouse. Plus, we offer covered parking and a beloved bark park for residents with pets. Shadow Hills combines the essentials of modern apartment living with the academic lifestyle at PCC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near PCC Sylvania Campus",
      "seo_description": "Find ideal living near PCC Sylvania Campus at Shadow Hills, offering comfort and convenience in Portland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-near-portland-state-university-southwest-portland",
      "search_query": "apartments near portland state university southwest portland",
      "category": "School",
      "h1_title": "Apartments Near Portland State University",
      "h2_subtitle": "Discover convenient apartment living at Shadow Hills, located near Portland State University in Southwest Portland. Perfect for students and faculty.",
      "page_copy": "Shadow Hills is an outstanding choice for those seeking apartments near Portland State University in Southwest Portland. Situated in a prime location, our community offers easy access to the university, making daily commutes a breeze. Whether you're a student or faculty member, you'll find our community fosters both an academic and social lifestyle, perfect for balancing work and leisure.\n\nIn addition to our ideal location, Shadow Hills features a variety of amenities designed with you in mind. Enjoy access to our 24-hour fitness center, perfect for squeezing in a workout between study sessions, or connect with fellow residents in our clubhouse, which offers complimentary Wi-Fi. For those with pets, our bark park is a favorite spot to let them play. At Shadow Hills, you'll find a supportive and engaging community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near PSU, Southwest Portland",
      "seo_description": "Experience apartment living near Portland State University at Shadow Hills in Southwest Portland, offering proximity and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-close-to-reed-college-multnomah-county",
      "search_query": "apartments close to reed college multnomah county",
      "category": "School",
      "h1_title": "Apartments Near Reed College",
      "h2_subtitle": "Discover ideal apartment living at Shadow Hills, located close to Reed College in Multnomah County. Perfect choice for students and faculty.",
      "page_copy": "If you're seeking a convenient spot close to Reed College, look no further than Shadow Hills. Our community is nestled in Multnomah County and offers a prime location for students and faculty looking for easy access to campus. The vibrant surroundings of Southwest Portland make Shadow Hills not just a place to live, but a community where residents can thrive both academically and socially.\n\nAt Shadow Hills, we prioritize comfort and connection. You can enjoy our community amenities like the 24-hour fitness center and the welcoming clubhouse with complimentary Wi-Fi, perfect for study groups or a casual meeting with classmates. Meanwhile, our bark park invites pet lovers to enjoy some outdoor fun with their furry friends. With covered parking also available, Shadow Hills combines convenience and modern living near Reed College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Reed College",
      "seo_description": "Discover Shadow Hills, offering ideal apartments near Reed College in Multnomah County, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-near-ohsu-hospital-portland",
      "search_query": "apartments near OHSU Hospital Portland",
      "category": "Hospital",
      "h1_title": "Apartments Near OHSU Hospital",
      "h2_subtitle": "Find perfect apartment living at Shadow Hills, ideally located close to OHSU Hospital in Portland. Great for healthcare staff and students.",
      "page_copy": "Located just a short drive from OHSU Hospital, Shadow Hills offers a convenient and comfortable home for hospital staff, students, and medical professionals seeking nearby living options. Our community in Southwest Portland provides an excellent balance of accessibility and tranquility, allowing residents to enjoy swift commutes while relaxing in a peaceful neighborhood.\n\nShadow Hills is designed with a range of amenities that cater specifically to the busy lifestyle of healthcare professionals. Our 24-hour fitness center is perfect for those irregular work hours, and our complimentary Wi-Fi in the clubhouse ensures you can always stay connected. For pet owners, our bark park is an essential feature. Add in the convenience of covered parking, and you'll find Shadow Hills has everything you need for modern living near OHSU Hospital.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OHSU Hospital Portland",
      "seo_description": "Explore Shadow Hills, featuring ideal apartments near OHSU Hospital in Portland, perfect for healthcare staff with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-portland-medical-center",
      "search_query": "apartments close to Providence Portland Medical Center in Multnomah County",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence Medical Center",
      "h2_subtitle": "Discover premium living at Shadow Hills, ideally situated close to Providence Portland Medical Center in Multnomah County. Perfect for medical staff.",
      "page_copy": "Shadow Hills stands out as a prime choice for those seeking apartments close to Providence Portland Medical Center. Nestled in Multnomah County, our community offers superb convenience for healthcare professionals, students, and staff who desire quick access to the medical center. Experience the pleasant balance of urban convenience and suburban tranquility that Southwest Portland has to offer.\n\nOur community is designed to accommodate the demanding schedules of those in the medical field, with amenities such as a 24-hour fitness center to help you maintain an active lifestyle on your own time. Connect with others in our welcoming clubhouse, featuring complimentary Wi-Fi, and take advantage of our covered parking for added peace of mind. Plus, pet owners will love our on-site bark park, making Shadow Hills a perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Providence Portland Medical Center",
      "seo_description": "Discover Shadow Hills, offering ideal living near Providence Portland Medical Center with modern amenities, perfect for medical professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-near-pioneer-courthouse-square-portland",
      "search_query": "apartments near Pioneer Courthouse Square Portland",
      "category": "Park",
      "h1_title": "Apartments by Pioneer Courthouse Square",
      "h2_subtitle": "Live conveniently close to Pioneer Courthouse Square at Shadow Hills. Enjoy thrilling downtown Portland lifestyle with ease and comfort.",
      "page_copy": "Shadow Hills offers the perfect blend of comfort and convenience for those looking for apartments near Pioneer Courthouse Square in Portland. Located within easy reach of the city's vibrant heart, residents can easily immerse themselves in downtown Portland's exciting cultural and social offerings while enjoying a peaceful living environment in Southwest Portland.\n\nOur community provides a variety of amenities designed for modern living. Enjoy access to a 24-hour fitness center, allowing flexibility to stay fit on your schedule. The clubhouse with complimentary Wi-Fi is a great spot for relaxation or catching up on work. For pet lovers, our bark park is ideal for spending quality time with furry friends. All these features, plus the convenience of covered parking, make Shadow Hills an ideal choice near Pioneer Courthouse Square.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pioneer Courthouse Square",
      "seo_description": "Explore Shadow Hills, offering ideal apartments near Pioneer Courthouse Square in Portland, with top-notch amenities for a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-by-laurelhurst-park-multnomah-county",
      "search_query": "apartments by Laurelhurst Park Multnomah County",
      "category": "Park",
      "h1_title": "Apartments Near Laurelhurst Park",
      "h2_subtitle": "Discover Shadow Hills, a serene residential community perfectly situated near Laurelhurst Park in Multnomah County. Experience nature and convenience.",
      "page_copy": "Enjoy the tranquility of nature while still being close to urban amenities at Shadow Hills, located conveniently near Laurelhurst Park in Multnomah County. Our apartment community offers residents a peaceful retreat in the bustling city of Portland, providing quick access to one of the city's most beloved green spaces. Perfect for individuals who appreciate outdoor activities and the beauty of nature.\n\nShadow Hills provides a wide range of modern amenities for comfort and convenience. Unwind after work at our sauna, stay active anytime with our 24-hour fitness center, and let your pets enjoy our on-site bark park. The clubhouse with complimentary Wi-Fi is perfect for catching up on tasks or simply relaxing. With covered parking available, Shadow Hills is the ideal choice for those wanting the best of both worlds near Laurelhurst Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Laurelhurst Park",
      "seo_description": "Discover Shadow Hills, offering serene apartments near Laurelhurst Park in Multnomah County with convenient amenities for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-close-to-mt-tabor-park-southwest-portland",
      "search_query": "apartments close to Mt. Tabor Park Southwest Portland",
      "category": "Park",
      "h1_title": "Apartments by Mt. Tabor Park",
      "h2_subtitle": "Live near Mt. Tabor Park at Shadow Hills in Southwest Portland. Experience the blend of natural beauty and modern urban living.",
      "page_copy": "Shadow Hills offers a prime location for those seeking apartments close to Mt. Tabor Park in Southwest Portland. Nestled in a scenic neighborhood, our community provides residents with easy access to the picturesque trails and open spaces of Mt. Tabor Park, perfect for outdoor enthusiasts and nature lovers.\n\nOur apartments are designed with comfort and functionality in mind, featuring modern amenities such as a 24-hour fitness center and a clubhouse with complimentary Wi-Fi. Enjoy the convenience of covered parking and the joy of having a bark park for your pets right on site. As a resident of Shadow Hills, you will appreciate being part of a community that values both relaxation and an active lifestyle, all while being close to the natural splendor of Mt. Tabor Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mt. Tabor Park",
      "seo_description": "Shadow Hills: Ideal apartments close to Mt. Tabor Park in Southwest Portland, offering modern amenities and easy access to outdoor beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-near-beaverton-tc-max-station-portland",
      "search_query": "apartments near beaverton tc max station portland",
      "category": "Transit",
      "h1_title": "Apartments by Beaverton TC MAX",
      "h2_subtitle": "Experience urban convenience with Shadow Hills apartments near Beaverton TC MAX Station in Portland. Ideal for commuters and urban dwellers alike.",
      "page_copy": "Discover the convenience of living at Shadow Hills, offering modern apartments near Beaverton TC MAX Station in Portland. Our strategic location is perfect for those who commute or enjoy frequent trips around the city, with the MAX station providing seamless connectivity to all that Portland has to offer.\n\nAt Shadow Hills, you can expect a blend of comfort and convenience. Our amenities include a clubhouse with complimentary Wi-Fi, perfect for remote work or relaxation, a vigorous 24-hour fitness center, and a bark park for your four-legged companion. Covered parking ensures your vehicle is always protected. Located in a vibrant area while still providing a peaceful community setting, Shadow Hills is an excellent choice for those seeking easy access to public transportation while enjoying a quality living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Beaverton TC Station",
      "seo_description": "Explore Shadow Hills, offering convenient apartments near Beaverton TC MAX Station in Portland, designed for commuters and urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-close-to-rose-quarter-transit-center",
      "search_query": "apartments close to rose quarter transit center multnomah county",
      "category": "Transit",
      "h1_title": "Apartments by Rose Quarter Transit Center",
      "h2_subtitle": "Shadow Hills offers convenient living close to Rose Quarter Transit Center in Multnomah County. Perfect for easy commuting and city accessibility.",
      "page_copy": "Shadow Hills provides the perfect location for those seeking apartments close to Rose Quarter Transit Center in Multnomah County. This prime position offers residents quick access to public transportation, making commutes and city exploration effortless. Whether heading to work or play, living near this transit hub means traveling without the hassle.\n\nOur community is designed with resident satisfaction in mind. Enjoy a variety of amenities including a sauna for relaxation, a 24-hour fitness center to stay active, and a clubhouse with complimentary Wi-Fi for connecting or unwinding. Pet owners will love our on-site bark park for their dogs. Additionally, our covered parking facility ensures protection from the elements. At Shadow Hills, you’ll find urban accessibility combined with a tranquil home environment, perfectly situated in Multnomah County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rose Quarter Transit Center",
      "seo_description": "Live at Shadow Hills, offering convenient apartments close to Rose Quarter Transit Center in Multnomah County, ideal for easy commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-by-hollywood-ne-42nd-ave-portland",
      "search_query": "apartments by hollywood/ne 42nd ave portland or",
      "category": "Transit",
      "h1_title": "Apartments Near Hollywood/NE 42nd Ave",
      "h2_subtitle": "Enjoy urban living at Shadow Hills, near Hollywood/NE 42nd Ave in Portland, OR. Experience easy access and vibrant city life.",
      "page_copy": "Discover the vibrancy of city living at Shadow Hills, offering exceptional apartments by Hollywood/NE 42nd Ave in Portland, OR. This central location places residents in the heart of it all, perfect for those who appreciate the energy and convenience of urban hotspots. From dining and entertainment to shopping and cultural venues, everything you need is within reach.\n\nOur community offers outstanding features to complement your lifestyle, including a modern clubhouse with complimentary Wi-Fi, a comprehensive 24-hour fitness center, and a convenient bark park for pet owners. Covered parking provides added security for your vehicle, making life at Shadow Hills both comfortable and practical. Enjoy the dynamic neighborhood near Hollywood/NE 42nd Ave while benefiting from a relaxing residential environment that feels like home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Hollywood/NE 42nd Ave",
      "seo_description": "Live at Shadow Hills, with prime apartments near Hollywood/NE 42nd Ave in Portland, OR. Enjoy vibrant urban living and essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166905",
      "source": "generator",
      "page_item_url": "apartments-near-psu-urban-center-sw-portland",
      "search_query": "apartments near psu urban center southwest portland",
      "category": "Transit",
      "h1_title": "Apartments Near PSU Urban Center",
      "h2_subtitle": "Live conveniently at Shadow Hills, located near PSU Urban Center in Southwest Portland. Perfect for students and city professionals alike.",
      "page_copy": "Experience the ideal living situation at Shadow Hills, offering modern apartments near the PSU Urban Center in Southwest Portland. This location is perfect for students, faculty, and professionals wanting convenient access to Portland State University and the vibrant downtown area. Enjoy the blend of academia and city life just moments from your doorstep.\n\nAt Shadow Hills, we provide an array of amenities designed for your comfort and convenience. Stay fit in our 24-hour fitness center, relax in our welcoming sauna, and utilize our clubhouse with complimentary Wi-Fi for all your online needs. Pet owners will appreciate our bark park, a delightful spot for your furry friends. The assurance of covered parking adds another layer of convenience, making Shadow Hills a superb choice for urban living in Southwest Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near PSU Urban Center",
      "seo_description": "Explore Shadow Hills, offering prime apartments near PSU Urban Center in Southwest Portland, perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5624"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372407448"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-MXVGG73H"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-537-6707 "
    }
  ],
  "custom_qb_id": "5624",
  "custom_repli_id": "18372407448",
  "custom_google_gtm_id": "\tGTM-MXVGG73H",
  "custom_ppc_tracking_phone_number": "844-537-6707 "
};

export const generatedAt = '2026-09-23T19:55:11.193Z';
